// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/config.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { DevConfig as DevConfig1 } from "./dev";
import { ModelConfig } from "./templates";
import { CreditsPricing } from "./usage";

export const protobufPackage = "api.devplan.types.config";

export interface PublicGlobalConfig {
  featureEstimation: EstimationConfig | undefined;
  featureFlags:
    | FeatureFlags
    | undefined;
  /** Used for v0 and bolt */
  prototypeRequest?: string | undefined;
  taskEstimation: EstimationConfig | undefined;
  ide?: IdeConfig | undefined;
  integrationCreditRewards: IntegrationCreditRewardsConfig | undefined;
}

export interface IdeConfig {
  specsEnabledIdes: string[];
}

export interface GlobalConfig {
  id: string;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
  tiers: TiersConfig | undefined;
  featureFlags: FeatureFlags | undefined;
  repoAnalysis: RepoAnalysisConfig | undefined;
  usage: UsageConfig | undefined;
  planning: PlanningConfig | undefined;
  prompts: PromptsConfig | undefined;
  agents: AgentsConfig | undefined;
  dev: DevConfig1 | undefined;
  creditsPricing: CreditsPricing | undefined;
  periodicRescan: PeriodicRescanConfig | undefined;
  integrationCreditRewards: IntegrationCreditRewardsConfig | undefined;
  internalOnboardingSlackChannelId?: string | undefined;
}

export interface IntegrationCreditRewardsConfig {
  codeCredits: number;
  communicationCredits: number;
  additionalContextCredits: number;
  composioCredits: number;
  maxCredits: number;
  goalsCredits: number;
  companyInfoCredits: number;
  teammateCredits: number;
  initialCredits?: number | undefined;
}

export interface PromptsConfig {
  prototypeRequest: string;
}

export interface PlanningConfig {
  featureEstimation: EstimationConfig | undefined;
  taskEstimation: EstimationConfig | undefined;
  simulation: SimulationConfig | undefined;
}

export interface SimulationConfig {
  lowAmbiguity?: AmbiguityMultiplierConfig | undefined;
  mediumAmbiguity?: AmbiguityMultiplierConfig | undefined;
  highAmbiguity?: AmbiguityMultiplierConfig | undefined;
}

export interface AmbiguityMultiplierConfig {
  /** Multiplier applied to min_hours estimate (default depends on level: low=0.9, medium=0.8, high=0.6) */
  minMultiplier?:
    | number
    | undefined;
  /** Multiplier applied to max_hours estimate (default depends on level: low=1.1, medium=1.4, high=2.0) */
  maxMultiplier?: number | undefined;
}

export interface EstimationConfig {
  timeBuckets: TimeBucketConfig[];
  ambiguityConfig: AmbiguityEstimateConfig | undefined;
}

export interface AmbiguityEstimateConfig {
  descriptions: AmbiguityLevelDescriptions | undefined;
}

export interface AmbiguityLevelDescriptions {
  low: string;
  medium: string;
  high: string;
}

export interface TimeBucketConfig {
  name: string;
  minHours: number;
  maxHours: number;
  description: string;
}

export interface TiersConfig {
  defaultUserTierId: string;
  trial?: TrialConfig | undefined;
}

export interface TrialConfig {
  defaultPriceId: string;
  defaultPeriod: number;
  cardRequiredPeriod?: number | undefined;
  cardlessPeriod?: number | undefined;
}

export interface UsageConfig {
  backgroundProcessingDisabled: boolean;
}

export interface LLMGlobalConfig {
  /** If model config is not set in the template, then this default config should be used. */
  defaultModelConfig: ModelConfig | undefined;
}

export interface FeatureFlags {
  enablePulse: boolean;
  wsWithAllowedExec: string[];
  enableMergeIdeas: boolean;
  wsJiraWebhook: string[];
  wsRunBlocklist: string[];
  wsProjectSummaryTab: string[];
  wsFeatureCatalogue: string[];
  wsEnableActivityCallsiteTracing: string[];
  wsCustomizableTemplates: string[];
  wsRequirementsTasksTab: string[];
  wsCatalogueFeatureStatus: string[];
  wsChats: string[];
  hidePersonalPayments: boolean;
  wsSlackIntegration: string[];
  wsTrends: string[];
  /**
   * Enables the knowledge agent tool in workspace chat for the listed company IDs.
   * Set to ["-1"] to enable globally for all workspaces.
   */
  wsKnowledgeAgent: string[];
  wsKnowledgeRedesign: string[];
  wsGranola: string[];
  wsApiKeys: string[];
  wsGoogleDrive: string[];
  wsProactiveTokenRefresh: string[];
  wsMeetingNotes: string[];
  wsSignals: string[];
  wsBugs: string[];
  wsCatalogueFeedback: string[];
  wsNotion: string[];
  wsInsights: string[];
  wsIntegrationsV2: string[];
  wsProjectStatusTab: string[];
  wsProjectAtAGlanceTab: string[];
  wsProjectSignalsTab: string[];
  wsProjectUpdates: string[];
  wsInsightCreation: string[];
  wsReporting: string[];
  wsCreateProjects: string[];
  wsHomeReportDelivery: string[];
  wsWeeklyHomeReports: string[];
  wsWeaverHome: string[];
  respectDisabledSpecs: string[];
  wsGenerativeMarkdownDirectives: string[];
  wsOnboardingFlow: string[];
  /** Shows legacy company roles (viewer, engineering, product, marketing, projects owner) in role pickers. */
  wsLegacyCompanyRoles: string[];
  openFrontDoor: boolean;
  wsSlackNativeDeepLinks: string[];
  wsWorkspaceMemories: string[];
  wsManagedConnections: string[];
  wsFeatureRequestInsights: string[];
  wsMcpDirectGraphQuery: string[];
  wsDashboards: string[];
  wsBillingUsage: string[];
  wsTeamsIntegration: string[];
  wsGoals: string[];
  /**
   * Workspace teams (team management + team digests). Not to be confused
   * with ws_teams_integration (Microsoft Teams).
   */
  wsTeams: string[];
  wsHybridEntitySearch: string[];
  plgDomainDiscovery: boolean;
  wsKnowledgeSearchPage: string[];
  wsInferredProjects: string[];
  /** Enables compact, byte-bounded v2 responses for MCP read tools. */
  wsMcpCompactResponses: string[];
  /**
   * Gates the external-document ingestion worker and the search/fetch tool
   * exposure for indexed Drive, Notion, and Confluence documents.
   */
  wsExternalDocuments: string[];
  /** Shows the add-custom-MCP-server control for the listed company IDs. */
  wsAddCustomMcpConnections: string[];
  /**
   * Enables automatic and manually submitted decision-extraction jobs.
   * Empty by default so extraction requires an explicit workspace rollout.
   */
  wsDecisionExtraction: string[];
  /** Shows dashboard scheduling and subscription controls. */
  wsDashboardSchedules: string[];
  /** Gates the Zoom meeting-transcript integration (OAuth connect + sync). */
  wsZoom: string[];
}

export interface RepoAnalysisConfig {
  flatten: RepoAnalysisConfig_Flatten | undefined;
  analysis: RepoAnalysisConfig_Analysis | undefined;
  processingIntervals: RepoAnalysisConfig_Intervals | undefined;
}

export interface RepoAnalysisConfig_Intervals {
  /** Is true, then no processing should be enabled at all. */
  disabled: boolean;
  /** How frequently each integration should be re-processed. */
  integrationSec: number;
  /** How frequently the system should try to pick up new repo for analysis. */
  reposSec: number;
}

export interface RepoAnalysisConfig_Analysis {
  model: ModelConfig | undefined;
}

export interface RepoAnalysisConfig_Flatten {
  compress: boolean;
  removeEmptyLines: boolean;
  outStyle: string;
  maxTokensPerChunk: number;
  maxRepoSizeMb: number;
  ignorePattern?:
    | string
    | undefined;
  /** Threshold in MB for a repo to be considered large */
  largeRepoThresholdMb: number;
  /** Additional ignore pattern for large repo */
  largeRepoIgnorePattern?: string | undefined;
  compressLarge: boolean;
}

export interface AgentsConfig {
  parallelPrompts: number;
  disableLangfuseTracing: boolean;
  disableUsageTraces: boolean;
  attachmentProcessing: AttachmentProcessingConfig | undefined;
  contextCompaction: ContextCompactionConfig | undefined;
}

export interface AttachmentProcessingConfig {
  /** Maximum tokens to include when summarizing documents (cl100k_base; default: 100000). */
  summaryMaxTokens: number;
}

export interface ContextCompactionConfig {
  /** Whether context compaction (summarization) is enabled. Default: enabled. */
  enabled?:
    | boolean
    | undefined;
  /** Maximum tokens (summary + messages) before triggering compaction (default: 100000) */
  maxTokens?:
    | number
    | undefined;
  /** Number of recent messages to keep after compaction (default: 6) */
  keepLastN?:
    | number
    | undefined;
  /** Minimum messages required before compaction triggers (default: 12) */
  minMessages?:
    | number
    | undefined;
  /** Maximum messages per summarization call to prevent huge LLM calls (default: 10) */
  maxSummarizationWindow?: number | undefined;
}

/** Configuration for the periodic automatic repository rescan job */
export interface PeriodicRescanConfig {
  /** Whether the periodic rescan job is enabled */
  enabled: boolean;
  /** How often to check if repos are due for rescan, in minutes */
  intervalMinutes: number;
  /** Rescan repos that haven't been scanned within this many minutes */
  periodMinutes: number;
}

export interface DevConfig {
}

export interface DevCommand {
}

function createBasePublicGlobalConfig(): PublicGlobalConfig {
  return {
    featureEstimation: undefined,
    featureFlags: undefined,
    prototypeRequest: undefined,
    taskEstimation: undefined,
    ide: undefined,
    integrationCreditRewards: undefined,
  };
}

export const PublicGlobalConfig: MessageFns<PublicGlobalConfig> = {
  encode(message: PublicGlobalConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.featureEstimation !== undefined) {
      EstimationConfig.encode(message.featureEstimation, writer.uint32(10).fork()).join();
    }
    if (message.featureFlags !== undefined) {
      FeatureFlags.encode(message.featureFlags, writer.uint32(18).fork()).join();
    }
    if (message.prototypeRequest !== undefined) {
      writer.uint32(26).string(message.prototypeRequest);
    }
    if (message.taskEstimation !== undefined) {
      EstimationConfig.encode(message.taskEstimation, writer.uint32(34).fork()).join();
    }
    if (message.ide !== undefined) {
      IdeConfig.encode(message.ide, writer.uint32(42).fork()).join();
    }
    if (message.integrationCreditRewards !== undefined) {
      IntegrationCreditRewardsConfig.encode(message.integrationCreditRewards, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PublicGlobalConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePublicGlobalConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.featureEstimation = EstimationConfig.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.featureFlags = FeatureFlags.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.prototypeRequest = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.taskEstimation = EstimationConfig.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ide = IdeConfig.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.integrationCreditRewards = IntegrationCreditRewardsConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PublicGlobalConfig {
    return {
      featureEstimation: isSet(object.featureEstimation)
        ? EstimationConfig.fromJSON(object.featureEstimation)
        : isSet(object.feature_estimation)
        ? EstimationConfig.fromJSON(object.feature_estimation)
        : undefined,
      featureFlags: isSet(object.featureFlags)
        ? FeatureFlags.fromJSON(object.featureFlags)
        : isSet(object.feature_flags)
        ? FeatureFlags.fromJSON(object.feature_flags)
        : undefined,
      prototypeRequest: isSet(object.prototypeRequest)
        ? globalThis.String(object.prototypeRequest)
        : isSet(object.prototype_request)
        ? globalThis.String(object.prototype_request)
        : undefined,
      taskEstimation: isSet(object.taskEstimation)
        ? EstimationConfig.fromJSON(object.taskEstimation)
        : isSet(object.task_estimation)
        ? EstimationConfig.fromJSON(object.task_estimation)
        : undefined,
      ide: isSet(object.ide) ? IdeConfig.fromJSON(object.ide) : undefined,
      integrationCreditRewards: isSet(object.integrationCreditRewards)
        ? IntegrationCreditRewardsConfig.fromJSON(object.integrationCreditRewards)
        : isSet(object.integration_credit_rewards)
        ? IntegrationCreditRewardsConfig.fromJSON(object.integration_credit_rewards)
        : undefined,
    };
  },

  toJSON(message: PublicGlobalConfig): unknown {
    const obj: any = {};
    if (message.featureEstimation !== undefined) {
      obj.featureEstimation = EstimationConfig.toJSON(message.featureEstimation);
    }
    if (message.featureFlags !== undefined) {
      obj.featureFlags = FeatureFlags.toJSON(message.featureFlags);
    }
    if (message.prototypeRequest !== undefined) {
      obj.prototypeRequest = message.prototypeRequest;
    }
    if (message.taskEstimation !== undefined) {
      obj.taskEstimation = EstimationConfig.toJSON(message.taskEstimation);
    }
    if (message.ide !== undefined) {
      obj.ide = IdeConfig.toJSON(message.ide);
    }
    if (message.integrationCreditRewards !== undefined) {
      obj.integrationCreditRewards = IntegrationCreditRewardsConfig.toJSON(message.integrationCreditRewards);
    }
    return obj;
  },

  create(base?: DeepPartial<PublicGlobalConfig>): PublicGlobalConfig {
    return PublicGlobalConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PublicGlobalConfig>): PublicGlobalConfig {
    const message = createBasePublicGlobalConfig();
    message.featureEstimation = (object.featureEstimation !== undefined && object.featureEstimation !== null)
      ? EstimationConfig.fromPartial(object.featureEstimation)
      : undefined;
    message.featureFlags = (object.featureFlags !== undefined && object.featureFlags !== null)
      ? FeatureFlags.fromPartial(object.featureFlags)
      : undefined;
    message.prototypeRequest = object.prototypeRequest ?? undefined;
    message.taskEstimation = (object.taskEstimation !== undefined && object.taskEstimation !== null)
      ? EstimationConfig.fromPartial(object.taskEstimation)
      : undefined;
    message.ide = (object.ide !== undefined && object.ide !== null) ? IdeConfig.fromPartial(object.ide) : undefined;
    message.integrationCreditRewards =
      (object.integrationCreditRewards !== undefined && object.integrationCreditRewards !== null)
        ? IntegrationCreditRewardsConfig.fromPartial(object.integrationCreditRewards)
        : undefined;
    return message;
  },
};

function createBaseIdeConfig(): IdeConfig {
  return { specsEnabledIdes: [] };
}

export const IdeConfig: MessageFns<IdeConfig> = {
  encode(message: IdeConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.specsEnabledIdes) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IdeConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIdeConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.specsEnabledIdes.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IdeConfig {
    return {
      specsEnabledIdes: globalThis.Array.isArray(object?.specsEnabledIdes)
        ? object.specsEnabledIdes.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.specs_enabled_ides)
        ? object.specs_enabled_ides.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: IdeConfig): unknown {
    const obj: any = {};
    if (message.specsEnabledIdes?.length) {
      obj.specsEnabledIdes = message.specsEnabledIdes;
    }
    return obj;
  },

  create(base?: DeepPartial<IdeConfig>): IdeConfig {
    return IdeConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<IdeConfig>): IdeConfig {
    const message = createBaseIdeConfig();
    message.specsEnabledIdes = object.specsEnabledIdes?.map((e) => e) || [];
    return message;
  },
};

function createBaseGlobalConfig(): GlobalConfig {
  return {
    id: "",
    createdAt: undefined,
    updatedAt: undefined,
    tiers: undefined,
    featureFlags: undefined,
    repoAnalysis: undefined,
    usage: undefined,
    planning: undefined,
    prompts: undefined,
    agents: undefined,
    dev: undefined,
    creditsPricing: undefined,
    periodicRescan: undefined,
    integrationCreditRewards: undefined,
    internalOnboardingSlackChannelId: undefined,
  };
}

export const GlobalConfig: MessageFns<GlobalConfig> = {
  encode(message: GlobalConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(18).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(26).fork()).join();
    }
    if (message.tiers !== undefined) {
      TiersConfig.encode(message.tiers, writer.uint32(34).fork()).join();
    }
    if (message.featureFlags !== undefined) {
      FeatureFlags.encode(message.featureFlags, writer.uint32(42).fork()).join();
    }
    if (message.repoAnalysis !== undefined) {
      RepoAnalysisConfig.encode(message.repoAnalysis, writer.uint32(50).fork()).join();
    }
    if (message.usage !== undefined) {
      UsageConfig.encode(message.usage, writer.uint32(58).fork()).join();
    }
    if (message.planning !== undefined) {
      PlanningConfig.encode(message.planning, writer.uint32(66).fork()).join();
    }
    if (message.prompts !== undefined) {
      PromptsConfig.encode(message.prompts, writer.uint32(74).fork()).join();
    }
    if (message.agents !== undefined) {
      AgentsConfig.encode(message.agents, writer.uint32(82).fork()).join();
    }
    if (message.dev !== undefined) {
      DevConfig1.encode(message.dev, writer.uint32(90).fork()).join();
    }
    if (message.creditsPricing !== undefined) {
      CreditsPricing.encode(message.creditsPricing, writer.uint32(98).fork()).join();
    }
    if (message.periodicRescan !== undefined) {
      PeriodicRescanConfig.encode(message.periodicRescan, writer.uint32(106).fork()).join();
    }
    if (message.integrationCreditRewards !== undefined) {
      IntegrationCreditRewardsConfig.encode(message.integrationCreditRewards, writer.uint32(114).fork()).join();
    }
    if (message.internalOnboardingSlackChannelId !== undefined) {
      writer.uint32(122).string(message.internalOnboardingSlackChannelId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GlobalConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGlobalConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tiers = TiersConfig.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.featureFlags = FeatureFlags.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.repoAnalysis = RepoAnalysisConfig.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.usage = UsageConfig.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.planning = PlanningConfig.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.prompts = PromptsConfig.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.agents = AgentsConfig.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.dev = DevConfig1.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.creditsPricing = CreditsPricing.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.periodicRescan = PeriodicRescanConfig.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.integrationCreditRewards = IntegrationCreditRewardsConfig.decode(reader, reader.uint32());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.internalOnboardingSlackChannelId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GlobalConfig {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      tiers: isSet(object.tiers) ? TiersConfig.fromJSON(object.tiers) : undefined,
      featureFlags: isSet(object.featureFlags)
        ? FeatureFlags.fromJSON(object.featureFlags)
        : isSet(object.feature_flags)
        ? FeatureFlags.fromJSON(object.feature_flags)
        : undefined,
      repoAnalysis: isSet(object.repoAnalysis)
        ? RepoAnalysisConfig.fromJSON(object.repoAnalysis)
        : isSet(object.repo_analysis)
        ? RepoAnalysisConfig.fromJSON(object.repo_analysis)
        : undefined,
      usage: isSet(object.usage) ? UsageConfig.fromJSON(object.usage) : undefined,
      planning: isSet(object.planning) ? PlanningConfig.fromJSON(object.planning) : undefined,
      prompts: isSet(object.prompts) ? PromptsConfig.fromJSON(object.prompts) : undefined,
      agents: isSet(object.agents) ? AgentsConfig.fromJSON(object.agents) : undefined,
      dev: isSet(object.dev) ? DevConfig1.fromJSON(object.dev) : undefined,
      creditsPricing: isSet(object.creditsPricing)
        ? CreditsPricing.fromJSON(object.creditsPricing)
        : isSet(object.credits_pricing)
        ? CreditsPricing.fromJSON(object.credits_pricing)
        : undefined,
      periodicRescan: isSet(object.periodicRescan)
        ? PeriodicRescanConfig.fromJSON(object.periodicRescan)
        : isSet(object.periodic_rescan)
        ? PeriodicRescanConfig.fromJSON(object.periodic_rescan)
        : undefined,
      integrationCreditRewards: isSet(object.integrationCreditRewards)
        ? IntegrationCreditRewardsConfig.fromJSON(object.integrationCreditRewards)
        : isSet(object.integration_credit_rewards)
        ? IntegrationCreditRewardsConfig.fromJSON(object.integration_credit_rewards)
        : undefined,
      internalOnboardingSlackChannelId: isSet(object.internalOnboardingSlackChannelId)
        ? globalThis.String(object.internalOnboardingSlackChannelId)
        : isSet(object.internal_onboarding_slack_channel_id)
        ? globalThis.String(object.internal_onboarding_slack_channel_id)
        : undefined,
    };
  },

  toJSON(message: GlobalConfig): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.tiers !== undefined) {
      obj.tiers = TiersConfig.toJSON(message.tiers);
    }
    if (message.featureFlags !== undefined) {
      obj.featureFlags = FeatureFlags.toJSON(message.featureFlags);
    }
    if (message.repoAnalysis !== undefined) {
      obj.repoAnalysis = RepoAnalysisConfig.toJSON(message.repoAnalysis);
    }
    if (message.usage !== undefined) {
      obj.usage = UsageConfig.toJSON(message.usage);
    }
    if (message.planning !== undefined) {
      obj.planning = PlanningConfig.toJSON(message.planning);
    }
    if (message.prompts !== undefined) {
      obj.prompts = PromptsConfig.toJSON(message.prompts);
    }
    if (message.agents !== undefined) {
      obj.agents = AgentsConfig.toJSON(message.agents);
    }
    if (message.dev !== undefined) {
      obj.dev = DevConfig1.toJSON(message.dev);
    }
    if (message.creditsPricing !== undefined) {
      obj.creditsPricing = CreditsPricing.toJSON(message.creditsPricing);
    }
    if (message.periodicRescan !== undefined) {
      obj.periodicRescan = PeriodicRescanConfig.toJSON(message.periodicRescan);
    }
    if (message.integrationCreditRewards !== undefined) {
      obj.integrationCreditRewards = IntegrationCreditRewardsConfig.toJSON(message.integrationCreditRewards);
    }
    if (message.internalOnboardingSlackChannelId !== undefined) {
      obj.internalOnboardingSlackChannelId = message.internalOnboardingSlackChannelId;
    }
    return obj;
  },

  create(base?: DeepPartial<GlobalConfig>): GlobalConfig {
    return GlobalConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GlobalConfig>): GlobalConfig {
    const message = createBaseGlobalConfig();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.tiers = (object.tiers !== undefined && object.tiers !== null)
      ? TiersConfig.fromPartial(object.tiers)
      : undefined;
    message.featureFlags = (object.featureFlags !== undefined && object.featureFlags !== null)
      ? FeatureFlags.fromPartial(object.featureFlags)
      : undefined;
    message.repoAnalysis = (object.repoAnalysis !== undefined && object.repoAnalysis !== null)
      ? RepoAnalysisConfig.fromPartial(object.repoAnalysis)
      : undefined;
    message.usage = (object.usage !== undefined && object.usage !== null)
      ? UsageConfig.fromPartial(object.usage)
      : undefined;
    message.planning = (object.planning !== undefined && object.planning !== null)
      ? PlanningConfig.fromPartial(object.planning)
      : undefined;
    message.prompts = (object.prompts !== undefined && object.prompts !== null)
      ? PromptsConfig.fromPartial(object.prompts)
      : undefined;
    message.agents = (object.agents !== undefined && object.agents !== null)
      ? AgentsConfig.fromPartial(object.agents)
      : undefined;
    message.dev = (object.dev !== undefined && object.dev !== null) ? DevConfig1.fromPartial(object.dev) : undefined;
    message.creditsPricing = (object.creditsPricing !== undefined && object.creditsPricing !== null)
      ? CreditsPricing.fromPartial(object.creditsPricing)
      : undefined;
    message.periodicRescan = (object.periodicRescan !== undefined && object.periodicRescan !== null)
      ? PeriodicRescanConfig.fromPartial(object.periodicRescan)
      : undefined;
    message.integrationCreditRewards =
      (object.integrationCreditRewards !== undefined && object.integrationCreditRewards !== null)
        ? IntegrationCreditRewardsConfig.fromPartial(object.integrationCreditRewards)
        : undefined;
    message.internalOnboardingSlackChannelId = object.internalOnboardingSlackChannelId ?? undefined;
    return message;
  },
};

function createBaseIntegrationCreditRewardsConfig(): IntegrationCreditRewardsConfig {
  return {
    codeCredits: 0,
    communicationCredits: 0,
    additionalContextCredits: 0,
    composioCredits: 0,
    maxCredits: 0,
    goalsCredits: 0,
    companyInfoCredits: 0,
    teammateCredits: 0,
    initialCredits: undefined,
  };
}

export const IntegrationCreditRewardsConfig: MessageFns<IntegrationCreditRewardsConfig> = {
  encode(message: IntegrationCreditRewardsConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.codeCredits !== 0) {
      writer.uint32(8).int32(message.codeCredits);
    }
    if (message.communicationCredits !== 0) {
      writer.uint32(16).int32(message.communicationCredits);
    }
    if (message.additionalContextCredits !== 0) {
      writer.uint32(24).int32(message.additionalContextCredits);
    }
    if (message.composioCredits !== 0) {
      writer.uint32(32).int32(message.composioCredits);
    }
    if (message.maxCredits !== 0) {
      writer.uint32(40).int32(message.maxCredits);
    }
    if (message.goalsCredits !== 0) {
      writer.uint32(48).int32(message.goalsCredits);
    }
    if (message.companyInfoCredits !== 0) {
      writer.uint32(56).int32(message.companyInfoCredits);
    }
    if (message.teammateCredits !== 0) {
      writer.uint32(64).int32(message.teammateCredits);
    }
    if (message.initialCredits !== undefined) {
      writer.uint32(72).int32(message.initialCredits);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IntegrationCreditRewardsConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntegrationCreditRewardsConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.codeCredits = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.communicationCredits = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.additionalContextCredits = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.composioCredits = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.maxCredits = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.goalsCredits = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.companyInfoCredits = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.teammateCredits = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.initialCredits = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IntegrationCreditRewardsConfig {
    return {
      codeCredits: isSet(object.codeCredits)
        ? globalThis.Number(object.codeCredits)
        : isSet(object.code_credits)
        ? globalThis.Number(object.code_credits)
        : 0,
      communicationCredits: isSet(object.communicationCredits)
        ? globalThis.Number(object.communicationCredits)
        : isSet(object.communication_credits)
        ? globalThis.Number(object.communication_credits)
        : 0,
      additionalContextCredits: isSet(object.additionalContextCredits)
        ? globalThis.Number(object.additionalContextCredits)
        : isSet(object.additional_context_credits)
        ? globalThis.Number(object.additional_context_credits)
        : 0,
      composioCredits: isSet(object.composioCredits)
        ? globalThis.Number(object.composioCredits)
        : isSet(object.composio_credits)
        ? globalThis.Number(object.composio_credits)
        : 0,
      maxCredits: isSet(object.maxCredits)
        ? globalThis.Number(object.maxCredits)
        : isSet(object.max_credits)
        ? globalThis.Number(object.max_credits)
        : 0,
      goalsCredits: isSet(object.goalsCredits)
        ? globalThis.Number(object.goalsCredits)
        : isSet(object.goals_credits)
        ? globalThis.Number(object.goals_credits)
        : 0,
      companyInfoCredits: isSet(object.companyInfoCredits)
        ? globalThis.Number(object.companyInfoCredits)
        : isSet(object.company_info_credits)
        ? globalThis.Number(object.company_info_credits)
        : 0,
      teammateCredits: isSet(object.teammateCredits)
        ? globalThis.Number(object.teammateCredits)
        : isSet(object.teammate_credits)
        ? globalThis.Number(object.teammate_credits)
        : 0,
      initialCredits: isSet(object.initialCredits)
        ? globalThis.Number(object.initialCredits)
        : isSet(object.initial_credits)
        ? globalThis.Number(object.initial_credits)
        : undefined,
    };
  },

  toJSON(message: IntegrationCreditRewardsConfig): unknown {
    const obj: any = {};
    if (message.codeCredits !== 0) {
      obj.codeCredits = Math.round(message.codeCredits);
    }
    if (message.communicationCredits !== 0) {
      obj.communicationCredits = Math.round(message.communicationCredits);
    }
    if (message.additionalContextCredits !== 0) {
      obj.additionalContextCredits = Math.round(message.additionalContextCredits);
    }
    if (message.composioCredits !== 0) {
      obj.composioCredits = Math.round(message.composioCredits);
    }
    if (message.maxCredits !== 0) {
      obj.maxCredits = Math.round(message.maxCredits);
    }
    if (message.goalsCredits !== 0) {
      obj.goalsCredits = Math.round(message.goalsCredits);
    }
    if (message.companyInfoCredits !== 0) {
      obj.companyInfoCredits = Math.round(message.companyInfoCredits);
    }
    if (message.teammateCredits !== 0) {
      obj.teammateCredits = Math.round(message.teammateCredits);
    }
    if (message.initialCredits !== undefined) {
      obj.initialCredits = Math.round(message.initialCredits);
    }
    return obj;
  },

  create(base?: DeepPartial<IntegrationCreditRewardsConfig>): IntegrationCreditRewardsConfig {
    return IntegrationCreditRewardsConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<IntegrationCreditRewardsConfig>): IntegrationCreditRewardsConfig {
    const message = createBaseIntegrationCreditRewardsConfig();
    message.codeCredits = object.codeCredits ?? 0;
    message.communicationCredits = object.communicationCredits ?? 0;
    message.additionalContextCredits = object.additionalContextCredits ?? 0;
    message.composioCredits = object.composioCredits ?? 0;
    message.maxCredits = object.maxCredits ?? 0;
    message.goalsCredits = object.goalsCredits ?? 0;
    message.companyInfoCredits = object.companyInfoCredits ?? 0;
    message.teammateCredits = object.teammateCredits ?? 0;
    message.initialCredits = object.initialCredits ?? undefined;
    return message;
  },
};

function createBasePromptsConfig(): PromptsConfig {
  return { prototypeRequest: "" };
}

export const PromptsConfig: MessageFns<PromptsConfig> = {
  encode(message: PromptsConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.prototypeRequest !== "") {
      writer.uint32(10).string(message.prototypeRequest);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PromptsConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePromptsConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.prototypeRequest = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PromptsConfig {
    return {
      prototypeRequest: isSet(object.prototypeRequest)
        ? globalThis.String(object.prototypeRequest)
        : isSet(object.prototype_request)
        ? globalThis.String(object.prototype_request)
        : "",
    };
  },

  toJSON(message: PromptsConfig): unknown {
    const obj: any = {};
    if (message.prototypeRequest !== "") {
      obj.prototypeRequest = message.prototypeRequest;
    }
    return obj;
  },

  create(base?: DeepPartial<PromptsConfig>): PromptsConfig {
    return PromptsConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PromptsConfig>): PromptsConfig {
    const message = createBasePromptsConfig();
    message.prototypeRequest = object.prototypeRequest ?? "";
    return message;
  },
};

function createBasePlanningConfig(): PlanningConfig {
  return { featureEstimation: undefined, taskEstimation: undefined, simulation: undefined };
}

export const PlanningConfig: MessageFns<PlanningConfig> = {
  encode(message: PlanningConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.featureEstimation !== undefined) {
      EstimationConfig.encode(message.featureEstimation, writer.uint32(10).fork()).join();
    }
    if (message.taskEstimation !== undefined) {
      EstimationConfig.encode(message.taskEstimation, writer.uint32(18).fork()).join();
    }
    if (message.simulation !== undefined) {
      SimulationConfig.encode(message.simulation, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanningConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanningConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.featureEstimation = EstimationConfig.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.taskEstimation = EstimationConfig.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.simulation = SimulationConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanningConfig {
    return {
      featureEstimation: isSet(object.featureEstimation)
        ? EstimationConfig.fromJSON(object.featureEstimation)
        : isSet(object.feature_estimation)
        ? EstimationConfig.fromJSON(object.feature_estimation)
        : undefined,
      taskEstimation: isSet(object.taskEstimation)
        ? EstimationConfig.fromJSON(object.taskEstimation)
        : isSet(object.task_estimation)
        ? EstimationConfig.fromJSON(object.task_estimation)
        : undefined,
      simulation: isSet(object.simulation) ? SimulationConfig.fromJSON(object.simulation) : undefined,
    };
  },

  toJSON(message: PlanningConfig): unknown {
    const obj: any = {};
    if (message.featureEstimation !== undefined) {
      obj.featureEstimation = EstimationConfig.toJSON(message.featureEstimation);
    }
    if (message.taskEstimation !== undefined) {
      obj.taskEstimation = EstimationConfig.toJSON(message.taskEstimation);
    }
    if (message.simulation !== undefined) {
      obj.simulation = SimulationConfig.toJSON(message.simulation);
    }
    return obj;
  },

  create(base?: DeepPartial<PlanningConfig>): PlanningConfig {
    return PlanningConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PlanningConfig>): PlanningConfig {
    const message = createBasePlanningConfig();
    message.featureEstimation = (object.featureEstimation !== undefined && object.featureEstimation !== null)
      ? EstimationConfig.fromPartial(object.featureEstimation)
      : undefined;
    message.taskEstimation = (object.taskEstimation !== undefined && object.taskEstimation !== null)
      ? EstimationConfig.fromPartial(object.taskEstimation)
      : undefined;
    message.simulation = (object.simulation !== undefined && object.simulation !== null)
      ? SimulationConfig.fromPartial(object.simulation)
      : undefined;
    return message;
  },
};

function createBaseSimulationConfig(): SimulationConfig {
  return { lowAmbiguity: undefined, mediumAmbiguity: undefined, highAmbiguity: undefined };
}

export const SimulationConfig: MessageFns<SimulationConfig> = {
  encode(message: SimulationConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.lowAmbiguity !== undefined) {
      AmbiguityMultiplierConfig.encode(message.lowAmbiguity, writer.uint32(10).fork()).join();
    }
    if (message.mediumAmbiguity !== undefined) {
      AmbiguityMultiplierConfig.encode(message.mediumAmbiguity, writer.uint32(18).fork()).join();
    }
    if (message.highAmbiguity !== undefined) {
      AmbiguityMultiplierConfig.encode(message.highAmbiguity, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SimulationConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSimulationConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.lowAmbiguity = AmbiguityMultiplierConfig.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.mediumAmbiguity = AmbiguityMultiplierConfig.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.highAmbiguity = AmbiguityMultiplierConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SimulationConfig {
    return {
      lowAmbiguity: isSet(object.lowAmbiguity)
        ? AmbiguityMultiplierConfig.fromJSON(object.lowAmbiguity)
        : isSet(object.low_ambiguity)
        ? AmbiguityMultiplierConfig.fromJSON(object.low_ambiguity)
        : undefined,
      mediumAmbiguity: isSet(object.mediumAmbiguity)
        ? AmbiguityMultiplierConfig.fromJSON(object.mediumAmbiguity)
        : isSet(object.medium_ambiguity)
        ? AmbiguityMultiplierConfig.fromJSON(object.medium_ambiguity)
        : undefined,
      highAmbiguity: isSet(object.highAmbiguity)
        ? AmbiguityMultiplierConfig.fromJSON(object.highAmbiguity)
        : isSet(object.high_ambiguity)
        ? AmbiguityMultiplierConfig.fromJSON(object.high_ambiguity)
        : undefined,
    };
  },

  toJSON(message: SimulationConfig): unknown {
    const obj: any = {};
    if (message.lowAmbiguity !== undefined) {
      obj.lowAmbiguity = AmbiguityMultiplierConfig.toJSON(message.lowAmbiguity);
    }
    if (message.mediumAmbiguity !== undefined) {
      obj.mediumAmbiguity = AmbiguityMultiplierConfig.toJSON(message.mediumAmbiguity);
    }
    if (message.highAmbiguity !== undefined) {
      obj.highAmbiguity = AmbiguityMultiplierConfig.toJSON(message.highAmbiguity);
    }
    return obj;
  },

  create(base?: DeepPartial<SimulationConfig>): SimulationConfig {
    return SimulationConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SimulationConfig>): SimulationConfig {
    const message = createBaseSimulationConfig();
    message.lowAmbiguity = (object.lowAmbiguity !== undefined && object.lowAmbiguity !== null)
      ? AmbiguityMultiplierConfig.fromPartial(object.lowAmbiguity)
      : undefined;
    message.mediumAmbiguity = (object.mediumAmbiguity !== undefined && object.mediumAmbiguity !== null)
      ? AmbiguityMultiplierConfig.fromPartial(object.mediumAmbiguity)
      : undefined;
    message.highAmbiguity = (object.highAmbiguity !== undefined && object.highAmbiguity !== null)
      ? AmbiguityMultiplierConfig.fromPartial(object.highAmbiguity)
      : undefined;
    return message;
  },
};

function createBaseAmbiguityMultiplierConfig(): AmbiguityMultiplierConfig {
  return { minMultiplier: undefined, maxMultiplier: undefined };
}

export const AmbiguityMultiplierConfig: MessageFns<AmbiguityMultiplierConfig> = {
  encode(message: AmbiguityMultiplierConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.minMultiplier !== undefined) {
      writer.uint32(13).float(message.minMultiplier);
    }
    if (message.maxMultiplier !== undefined) {
      writer.uint32(21).float(message.maxMultiplier);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AmbiguityMultiplierConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAmbiguityMultiplierConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.minMultiplier = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.maxMultiplier = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AmbiguityMultiplierConfig {
    return {
      minMultiplier: isSet(object.minMultiplier)
        ? globalThis.Number(object.minMultiplier)
        : isSet(object.min_multiplier)
        ? globalThis.Number(object.min_multiplier)
        : undefined,
      maxMultiplier: isSet(object.maxMultiplier)
        ? globalThis.Number(object.maxMultiplier)
        : isSet(object.max_multiplier)
        ? globalThis.Number(object.max_multiplier)
        : undefined,
    };
  },

  toJSON(message: AmbiguityMultiplierConfig): unknown {
    const obj: any = {};
    if (message.minMultiplier !== undefined) {
      obj.minMultiplier = message.minMultiplier;
    }
    if (message.maxMultiplier !== undefined) {
      obj.maxMultiplier = message.maxMultiplier;
    }
    return obj;
  },

  create(base?: DeepPartial<AmbiguityMultiplierConfig>): AmbiguityMultiplierConfig {
    return AmbiguityMultiplierConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AmbiguityMultiplierConfig>): AmbiguityMultiplierConfig {
    const message = createBaseAmbiguityMultiplierConfig();
    message.minMultiplier = object.minMultiplier ?? undefined;
    message.maxMultiplier = object.maxMultiplier ?? undefined;
    return message;
  },
};

function createBaseEstimationConfig(): EstimationConfig {
  return { timeBuckets: [], ambiguityConfig: undefined };
}

export const EstimationConfig: MessageFns<EstimationConfig> = {
  encode(message: EstimationConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.timeBuckets) {
      TimeBucketConfig.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.ambiguityConfig !== undefined) {
      AmbiguityEstimateConfig.encode(message.ambiguityConfig, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EstimationConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEstimationConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.timeBuckets.push(TimeBucketConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ambiguityConfig = AmbiguityEstimateConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EstimationConfig {
    return {
      timeBuckets: globalThis.Array.isArray(object?.timeBuckets)
        ? object.timeBuckets.map((e: any) => TimeBucketConfig.fromJSON(e))
        : globalThis.Array.isArray(object?.time_buckets)
        ? object.time_buckets.map((e: any) => TimeBucketConfig.fromJSON(e))
        : [],
      ambiguityConfig: isSet(object.ambiguityConfig)
        ? AmbiguityEstimateConfig.fromJSON(object.ambiguityConfig)
        : isSet(object.ambiguity_config)
        ? AmbiguityEstimateConfig.fromJSON(object.ambiguity_config)
        : undefined,
    };
  },

  toJSON(message: EstimationConfig): unknown {
    const obj: any = {};
    if (message.timeBuckets?.length) {
      obj.timeBuckets = message.timeBuckets.map((e) => TimeBucketConfig.toJSON(e));
    }
    if (message.ambiguityConfig !== undefined) {
      obj.ambiguityConfig = AmbiguityEstimateConfig.toJSON(message.ambiguityConfig);
    }
    return obj;
  },

  create(base?: DeepPartial<EstimationConfig>): EstimationConfig {
    return EstimationConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EstimationConfig>): EstimationConfig {
    const message = createBaseEstimationConfig();
    message.timeBuckets = object.timeBuckets?.map((e) => TimeBucketConfig.fromPartial(e)) || [];
    message.ambiguityConfig = (object.ambiguityConfig !== undefined && object.ambiguityConfig !== null)
      ? AmbiguityEstimateConfig.fromPartial(object.ambiguityConfig)
      : undefined;
    return message;
  },
};

function createBaseAmbiguityEstimateConfig(): AmbiguityEstimateConfig {
  return { descriptions: undefined };
}

export const AmbiguityEstimateConfig: MessageFns<AmbiguityEstimateConfig> = {
  encode(message: AmbiguityEstimateConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.descriptions !== undefined) {
      AmbiguityLevelDescriptions.encode(message.descriptions, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AmbiguityEstimateConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAmbiguityEstimateConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.descriptions = AmbiguityLevelDescriptions.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AmbiguityEstimateConfig {
    return {
      descriptions: isSet(object.descriptions) ? AmbiguityLevelDescriptions.fromJSON(object.descriptions) : undefined,
    };
  },

  toJSON(message: AmbiguityEstimateConfig): unknown {
    const obj: any = {};
    if (message.descriptions !== undefined) {
      obj.descriptions = AmbiguityLevelDescriptions.toJSON(message.descriptions);
    }
    return obj;
  },

  create(base?: DeepPartial<AmbiguityEstimateConfig>): AmbiguityEstimateConfig {
    return AmbiguityEstimateConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AmbiguityEstimateConfig>): AmbiguityEstimateConfig {
    const message = createBaseAmbiguityEstimateConfig();
    message.descriptions = (object.descriptions !== undefined && object.descriptions !== null)
      ? AmbiguityLevelDescriptions.fromPartial(object.descriptions)
      : undefined;
    return message;
  },
};

function createBaseAmbiguityLevelDescriptions(): AmbiguityLevelDescriptions {
  return { low: "", medium: "", high: "" };
}

export const AmbiguityLevelDescriptions: MessageFns<AmbiguityLevelDescriptions> = {
  encode(message: AmbiguityLevelDescriptions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.low !== "") {
      writer.uint32(10).string(message.low);
    }
    if (message.medium !== "") {
      writer.uint32(18).string(message.medium);
    }
    if (message.high !== "") {
      writer.uint32(26).string(message.high);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AmbiguityLevelDescriptions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAmbiguityLevelDescriptions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.low = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.medium = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.high = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AmbiguityLevelDescriptions {
    return {
      low: isSet(object.low) ? globalThis.String(object.low) : "",
      medium: isSet(object.medium) ? globalThis.String(object.medium) : "",
      high: isSet(object.high) ? globalThis.String(object.high) : "",
    };
  },

  toJSON(message: AmbiguityLevelDescriptions): unknown {
    const obj: any = {};
    if (message.low !== "") {
      obj.low = message.low;
    }
    if (message.medium !== "") {
      obj.medium = message.medium;
    }
    if (message.high !== "") {
      obj.high = message.high;
    }
    return obj;
  },

  create(base?: DeepPartial<AmbiguityLevelDescriptions>): AmbiguityLevelDescriptions {
    return AmbiguityLevelDescriptions.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AmbiguityLevelDescriptions>): AmbiguityLevelDescriptions {
    const message = createBaseAmbiguityLevelDescriptions();
    message.low = object.low ?? "";
    message.medium = object.medium ?? "";
    message.high = object.high ?? "";
    return message;
  },
};

function createBaseTimeBucketConfig(): TimeBucketConfig {
  return { name: "", minHours: 0, maxHours: 0, description: "" };
}

export const TimeBucketConfig: MessageFns<TimeBucketConfig> = {
  encode(message: TimeBucketConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.minHours !== 0) {
      writer.uint32(16).int32(message.minHours);
    }
    if (message.maxHours !== 0) {
      writer.uint32(24).int32(message.maxHours);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TimeBucketConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimeBucketConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.minHours = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.maxHours = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TimeBucketConfig {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      minHours: isSet(object.minHours)
        ? globalThis.Number(object.minHours)
        : isSet(object.min_hours)
        ? globalThis.Number(object.min_hours)
        : 0,
      maxHours: isSet(object.maxHours)
        ? globalThis.Number(object.maxHours)
        : isSet(object.max_hours)
        ? globalThis.Number(object.max_hours)
        : 0,
      description: isSet(object.description) ? globalThis.String(object.description) : "",
    };
  },

  toJSON(message: TimeBucketConfig): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.minHours !== 0) {
      obj.minHours = Math.round(message.minHours);
    }
    if (message.maxHours !== 0) {
      obj.maxHours = Math.round(message.maxHours);
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    return obj;
  },

  create(base?: DeepPartial<TimeBucketConfig>): TimeBucketConfig {
    return TimeBucketConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TimeBucketConfig>): TimeBucketConfig {
    const message = createBaseTimeBucketConfig();
    message.name = object.name ?? "";
    message.minHours = object.minHours ?? 0;
    message.maxHours = object.maxHours ?? 0;
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseTiersConfig(): TiersConfig {
  return { defaultUserTierId: "", trial: undefined };
}

export const TiersConfig: MessageFns<TiersConfig> = {
  encode(message: TiersConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.defaultUserTierId !== "") {
      writer.uint32(10).string(message.defaultUserTierId);
    }
    if (message.trial !== undefined) {
      TrialConfig.encode(message.trial, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TiersConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTiersConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.defaultUserTierId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.trial = TrialConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TiersConfig {
    return {
      defaultUserTierId: isSet(object.defaultUserTierId)
        ? globalThis.String(object.defaultUserTierId)
        : isSet(object.default_user_tier_id)
        ? globalThis.String(object.default_user_tier_id)
        : "",
      trial: isSet(object.trial) ? TrialConfig.fromJSON(object.trial) : undefined,
    };
  },

  toJSON(message: TiersConfig): unknown {
    const obj: any = {};
    if (message.defaultUserTierId !== "") {
      obj.defaultUserTierId = message.defaultUserTierId;
    }
    if (message.trial !== undefined) {
      obj.trial = TrialConfig.toJSON(message.trial);
    }
    return obj;
  },

  create(base?: DeepPartial<TiersConfig>): TiersConfig {
    return TiersConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TiersConfig>): TiersConfig {
    const message = createBaseTiersConfig();
    message.defaultUserTierId = object.defaultUserTierId ?? "";
    message.trial = (object.trial !== undefined && object.trial !== null)
      ? TrialConfig.fromPartial(object.trial)
      : undefined;
    return message;
  },
};

function createBaseTrialConfig(): TrialConfig {
  return { defaultPriceId: "", defaultPeriod: 0, cardRequiredPeriod: undefined, cardlessPeriod: undefined };
}

export const TrialConfig: MessageFns<TrialConfig> = {
  encode(message: TrialConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.defaultPriceId !== "") {
      writer.uint32(10).string(message.defaultPriceId);
    }
    if (message.defaultPeriod !== 0) {
      writer.uint32(16).int32(message.defaultPeriod);
    }
    if (message.cardRequiredPeriod !== undefined) {
      writer.uint32(24).int32(message.cardRequiredPeriod);
    }
    if (message.cardlessPeriod !== undefined) {
      writer.uint32(32).int32(message.cardlessPeriod);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TrialConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrialConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.defaultPriceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.defaultPeriod = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.cardRequiredPeriod = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.cardlessPeriod = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TrialConfig {
    return {
      defaultPriceId: isSet(object.defaultPriceId)
        ? globalThis.String(object.defaultPriceId)
        : isSet(object.default_price_id)
        ? globalThis.String(object.default_price_id)
        : "",
      defaultPeriod: isSet(object.defaultPeriod)
        ? globalThis.Number(object.defaultPeriod)
        : isSet(object.default_period)
        ? globalThis.Number(object.default_period)
        : 0,
      cardRequiredPeriod: isSet(object.cardRequiredPeriod)
        ? globalThis.Number(object.cardRequiredPeriod)
        : isSet(object.card_required_period)
        ? globalThis.Number(object.card_required_period)
        : undefined,
      cardlessPeriod: isSet(object.cardlessPeriod)
        ? globalThis.Number(object.cardlessPeriod)
        : isSet(object.cardless_period)
        ? globalThis.Number(object.cardless_period)
        : undefined,
    };
  },

  toJSON(message: TrialConfig): unknown {
    const obj: any = {};
    if (message.defaultPriceId !== "") {
      obj.defaultPriceId = message.defaultPriceId;
    }
    if (message.defaultPeriod !== 0) {
      obj.defaultPeriod = Math.round(message.defaultPeriod);
    }
    if (message.cardRequiredPeriod !== undefined) {
      obj.cardRequiredPeriod = Math.round(message.cardRequiredPeriod);
    }
    if (message.cardlessPeriod !== undefined) {
      obj.cardlessPeriod = Math.round(message.cardlessPeriod);
    }
    return obj;
  },

  create(base?: DeepPartial<TrialConfig>): TrialConfig {
    return TrialConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TrialConfig>): TrialConfig {
    const message = createBaseTrialConfig();
    message.defaultPriceId = object.defaultPriceId ?? "";
    message.defaultPeriod = object.defaultPeriod ?? 0;
    message.cardRequiredPeriod = object.cardRequiredPeriod ?? undefined;
    message.cardlessPeriod = object.cardlessPeriod ?? undefined;
    return message;
  },
};

function createBaseUsageConfig(): UsageConfig {
  return { backgroundProcessingDisabled: false };
}

export const UsageConfig: MessageFns<UsageConfig> = {
  encode(message: UsageConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.backgroundProcessingDisabled !== false) {
      writer.uint32(8).bool(message.backgroundProcessingDisabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UsageConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUsageConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.backgroundProcessingDisabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UsageConfig {
    return {
      backgroundProcessingDisabled: isSet(object.backgroundProcessingDisabled)
        ? globalThis.Boolean(object.backgroundProcessingDisabled)
        : isSet(object.background_processing_disabled)
        ? globalThis.Boolean(object.background_processing_disabled)
        : false,
    };
  },

  toJSON(message: UsageConfig): unknown {
    const obj: any = {};
    if (message.backgroundProcessingDisabled !== false) {
      obj.backgroundProcessingDisabled = message.backgroundProcessingDisabled;
    }
    return obj;
  },

  create(base?: DeepPartial<UsageConfig>): UsageConfig {
    return UsageConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UsageConfig>): UsageConfig {
    const message = createBaseUsageConfig();
    message.backgroundProcessingDisabled = object.backgroundProcessingDisabled ?? false;
    return message;
  },
};

function createBaseLLMGlobalConfig(): LLMGlobalConfig {
  return { defaultModelConfig: undefined };
}

export const LLMGlobalConfig: MessageFns<LLMGlobalConfig> = {
  encode(message: LLMGlobalConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.defaultModelConfig !== undefined) {
      ModelConfig.encode(message.defaultModelConfig, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LLMGlobalConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLLMGlobalConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.defaultModelConfig = ModelConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LLMGlobalConfig {
    return {
      defaultModelConfig: isSet(object.defaultModelConfig)
        ? ModelConfig.fromJSON(object.defaultModelConfig)
        : isSet(object.default_model_config)
        ? ModelConfig.fromJSON(object.default_model_config)
        : undefined,
    };
  },

  toJSON(message: LLMGlobalConfig): unknown {
    const obj: any = {};
    if (message.defaultModelConfig !== undefined) {
      obj.defaultModelConfig = ModelConfig.toJSON(message.defaultModelConfig);
    }
    return obj;
  },

  create(base?: DeepPartial<LLMGlobalConfig>): LLMGlobalConfig {
    return LLMGlobalConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LLMGlobalConfig>): LLMGlobalConfig {
    const message = createBaseLLMGlobalConfig();
    message.defaultModelConfig = (object.defaultModelConfig !== undefined && object.defaultModelConfig !== null)
      ? ModelConfig.fromPartial(object.defaultModelConfig)
      : undefined;
    return message;
  },
};

function createBaseFeatureFlags(): FeatureFlags {
  return {
    enablePulse: false,
    wsWithAllowedExec: [],
    enableMergeIdeas: false,
    wsJiraWebhook: [],
    wsRunBlocklist: [],
    wsProjectSummaryTab: [],
    wsFeatureCatalogue: [],
    wsEnableActivityCallsiteTracing: [],
    wsCustomizableTemplates: [],
    wsRequirementsTasksTab: [],
    wsCatalogueFeatureStatus: [],
    wsChats: [],
    hidePersonalPayments: false,
    wsSlackIntegration: [],
    wsTrends: [],
    wsKnowledgeAgent: [],
    wsKnowledgeRedesign: [],
    wsGranola: [],
    wsApiKeys: [],
    wsGoogleDrive: [],
    wsProactiveTokenRefresh: [],
    wsMeetingNotes: [],
    wsSignals: [],
    wsBugs: [],
    wsCatalogueFeedback: [],
    wsNotion: [],
    wsInsights: [],
    wsIntegrationsV2: [],
    wsProjectStatusTab: [],
    wsProjectAtAGlanceTab: [],
    wsProjectSignalsTab: [],
    wsProjectUpdates: [],
    wsInsightCreation: [],
    wsReporting: [],
    wsCreateProjects: [],
    wsHomeReportDelivery: [],
    wsWeeklyHomeReports: [],
    wsWeaverHome: [],
    respectDisabledSpecs: [],
    wsGenerativeMarkdownDirectives: [],
    wsOnboardingFlow: [],
    wsLegacyCompanyRoles: [],
    openFrontDoor: false,
    wsSlackNativeDeepLinks: [],
    wsWorkspaceMemories: [],
    wsManagedConnections: [],
    wsFeatureRequestInsights: [],
    wsMcpDirectGraphQuery: [],
    wsDashboards: [],
    wsBillingUsage: [],
    wsTeamsIntegration: [],
    wsGoals: [],
    wsTeams: [],
    wsHybridEntitySearch: [],
    plgDomainDiscovery: false,
    wsKnowledgeSearchPage: [],
    wsInferredProjects: [],
    wsMcpCompactResponses: [],
    wsExternalDocuments: [],
    wsAddCustomMcpConnections: [],
    wsDecisionExtraction: [],
    wsDashboardSchedules: [],
    wsZoom: [],
  };
}

export const FeatureFlags: MessageFns<FeatureFlags> = {
  encode(message: FeatureFlags, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enablePulse !== false) {
      writer.uint32(64).bool(message.enablePulse);
    }
    for (const v of message.wsWithAllowedExec) {
      writer.uint32(138).string(v!);
    }
    if (message.enableMergeIdeas !== false) {
      writer.uint32(192).bool(message.enableMergeIdeas);
    }
    for (const v of message.wsJiraWebhook) {
      writer.uint32(210).string(v!);
    }
    for (const v of message.wsRunBlocklist) {
      writer.uint32(314).string(v!);
    }
    for (const v of message.wsProjectSummaryTab) {
      writer.uint32(338).string(v!);
    }
    for (const v of message.wsFeatureCatalogue) {
      writer.uint32(346).string(v!);
    }
    for (const v of message.wsEnableActivityCallsiteTracing) {
      writer.uint32(354).string(v!);
    }
    for (const v of message.wsCustomizableTemplates) {
      writer.uint32(362).string(v!);
    }
    for (const v of message.wsRequirementsTasksTab) {
      writer.uint32(394).string(v!);
    }
    for (const v of message.wsCatalogueFeatureStatus) {
      writer.uint32(410).string(v!);
    }
    for (const v of message.wsChats) {
      writer.uint32(426).string(v!);
    }
    if (message.hidePersonalPayments !== false) {
      writer.uint32(440).bool(message.hidePersonalPayments);
    }
    for (const v of message.wsSlackIntegration) {
      writer.uint32(466).string(v!);
    }
    for (const v of message.wsTrends) {
      writer.uint32(474).string(v!);
    }
    for (const v of message.wsKnowledgeAgent) {
      writer.uint32(498).string(v!);
    }
    for (const v of message.wsKnowledgeRedesign) {
      writer.uint32(506).string(v!);
    }
    for (const v of message.wsGranola) {
      writer.uint32(514).string(v!);
    }
    for (const v of message.wsApiKeys) {
      writer.uint32(522).string(v!);
    }
    for (const v of message.wsGoogleDrive) {
      writer.uint32(530).string(v!);
    }
    for (const v of message.wsProactiveTokenRefresh) {
      writer.uint32(546).string(v!);
    }
    for (const v of message.wsMeetingNotes) {
      writer.uint32(554).string(v!);
    }
    for (const v of message.wsSignals) {
      writer.uint32(562).string(v!);
    }
    for (const v of message.wsBugs) {
      writer.uint32(570).string(v!);
    }
    for (const v of message.wsCatalogueFeedback) {
      writer.uint32(586).string(v!);
    }
    for (const v of message.wsNotion) {
      writer.uint32(594).string(v!);
    }
    for (const v of message.wsInsights) {
      writer.uint32(602).string(v!);
    }
    for (const v of message.wsIntegrationsV2) {
      writer.uint32(610).string(v!);
    }
    for (const v of message.wsProjectStatusTab) {
      writer.uint32(618).string(v!);
    }
    for (const v of message.wsProjectAtAGlanceTab) {
      writer.uint32(626).string(v!);
    }
    for (const v of message.wsProjectSignalsTab) {
      writer.uint32(634).string(v!);
    }
    for (const v of message.wsProjectUpdates) {
      writer.uint32(642).string(v!);
    }
    for (const v of message.wsInsightCreation) {
      writer.uint32(650).string(v!);
    }
    for (const v of message.wsReporting) {
      writer.uint32(658).string(v!);
    }
    for (const v of message.wsCreateProjects) {
      writer.uint32(666).string(v!);
    }
    for (const v of message.wsHomeReportDelivery) {
      writer.uint32(674).string(v!);
    }
    for (const v of message.wsWeeklyHomeReports) {
      writer.uint32(738).string(v!);
    }
    for (const v of message.wsWeaverHome) {
      writer.uint32(682).string(v!);
    }
    for (const v of message.respectDisabledSpecs) {
      writer.uint32(690).string(v!);
    }
    for (const v of message.wsGenerativeMarkdownDirectives) {
      writer.uint32(698).string(v!);
    }
    for (const v of message.wsOnboardingFlow) {
      writer.uint32(706).string(v!);
    }
    for (const v of message.wsLegacyCompanyRoles) {
      writer.uint32(714).string(v!);
    }
    if (message.openFrontDoor !== false) {
      writer.uint32(720).bool(message.openFrontDoor);
    }
    for (const v of message.wsSlackNativeDeepLinks) {
      writer.uint32(730).string(v!);
    }
    for (const v of message.wsWorkspaceMemories) {
      writer.uint32(746).string(v!);
    }
    for (const v of message.wsManagedConnections) {
      writer.uint32(754).string(v!);
    }
    for (const v of message.wsFeatureRequestInsights) {
      writer.uint32(762).string(v!);
    }
    for (const v of message.wsMcpDirectGraphQuery) {
      writer.uint32(770).string(v!);
    }
    for (const v of message.wsDashboards) {
      writer.uint32(778).string(v!);
    }
    for (const v of message.wsBillingUsage) {
      writer.uint32(786).string(v!);
    }
    for (const v of message.wsTeamsIntegration) {
      writer.uint32(794).string(v!);
    }
    for (const v of message.wsGoals) {
      writer.uint32(802).string(v!);
    }
    for (const v of message.wsTeams) {
      writer.uint32(810).string(v!);
    }
    for (const v of message.wsHybridEntitySearch) {
      writer.uint32(818).string(v!);
    }
    if (message.plgDomainDiscovery !== false) {
      writer.uint32(880).bool(message.plgDomainDiscovery);
    }
    for (const v of message.wsKnowledgeSearchPage) {
      writer.uint32(826).string(v!);
    }
    for (const v of message.wsInferredProjects) {
      writer.uint32(834).string(v!);
    }
    for (const v of message.wsMcpCompactResponses) {
      writer.uint32(842).string(v!);
    }
    for (const v of message.wsExternalDocuments) {
      writer.uint32(850).string(v!);
    }
    for (const v of message.wsAddCustomMcpConnections) {
      writer.uint32(858).string(v!);
    }
    for (const v of message.wsDecisionExtraction) {
      writer.uint32(866).string(v!);
    }
    for (const v of message.wsDashboardSchedules) {
      writer.uint32(890).string(v!);
    }
    for (const v of message.wsZoom) {
      writer.uint32(898).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FeatureFlags {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFeatureFlags();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.enablePulse = reader.bool();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.wsWithAllowedExec.push(reader.string());
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.enableMergeIdeas = reader.bool();
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.wsJiraWebhook.push(reader.string());
          continue;
        }
        case 39: {
          if (tag !== 314) {
            break;
          }

          message.wsRunBlocklist.push(reader.string());
          continue;
        }
        case 42: {
          if (tag !== 338) {
            break;
          }

          message.wsProjectSummaryTab.push(reader.string());
          continue;
        }
        case 43: {
          if (tag !== 346) {
            break;
          }

          message.wsFeatureCatalogue.push(reader.string());
          continue;
        }
        case 44: {
          if (tag !== 354) {
            break;
          }

          message.wsEnableActivityCallsiteTracing.push(reader.string());
          continue;
        }
        case 45: {
          if (tag !== 362) {
            break;
          }

          message.wsCustomizableTemplates.push(reader.string());
          continue;
        }
        case 49: {
          if (tag !== 394) {
            break;
          }

          message.wsRequirementsTasksTab.push(reader.string());
          continue;
        }
        case 51: {
          if (tag !== 410) {
            break;
          }

          message.wsCatalogueFeatureStatus.push(reader.string());
          continue;
        }
        case 53: {
          if (tag !== 426) {
            break;
          }

          message.wsChats.push(reader.string());
          continue;
        }
        case 55: {
          if (tag !== 440) {
            break;
          }

          message.hidePersonalPayments = reader.bool();
          continue;
        }
        case 58: {
          if (tag !== 466) {
            break;
          }

          message.wsSlackIntegration.push(reader.string());
          continue;
        }
        case 59: {
          if (tag !== 474) {
            break;
          }

          message.wsTrends.push(reader.string());
          continue;
        }
        case 62: {
          if (tag !== 498) {
            break;
          }

          message.wsKnowledgeAgent.push(reader.string());
          continue;
        }
        case 63: {
          if (tag !== 506) {
            break;
          }

          message.wsKnowledgeRedesign.push(reader.string());
          continue;
        }
        case 64: {
          if (tag !== 514) {
            break;
          }

          message.wsGranola.push(reader.string());
          continue;
        }
        case 65: {
          if (tag !== 522) {
            break;
          }

          message.wsApiKeys.push(reader.string());
          continue;
        }
        case 66: {
          if (tag !== 530) {
            break;
          }

          message.wsGoogleDrive.push(reader.string());
          continue;
        }
        case 68: {
          if (tag !== 546) {
            break;
          }

          message.wsProactiveTokenRefresh.push(reader.string());
          continue;
        }
        case 69: {
          if (tag !== 554) {
            break;
          }

          message.wsMeetingNotes.push(reader.string());
          continue;
        }
        case 70: {
          if (tag !== 562) {
            break;
          }

          message.wsSignals.push(reader.string());
          continue;
        }
        case 71: {
          if (tag !== 570) {
            break;
          }

          message.wsBugs.push(reader.string());
          continue;
        }
        case 73: {
          if (tag !== 586) {
            break;
          }

          message.wsCatalogueFeedback.push(reader.string());
          continue;
        }
        case 74: {
          if (tag !== 594) {
            break;
          }

          message.wsNotion.push(reader.string());
          continue;
        }
        case 75: {
          if (tag !== 602) {
            break;
          }

          message.wsInsights.push(reader.string());
          continue;
        }
        case 76: {
          if (tag !== 610) {
            break;
          }

          message.wsIntegrationsV2.push(reader.string());
          continue;
        }
        case 77: {
          if (tag !== 618) {
            break;
          }

          message.wsProjectStatusTab.push(reader.string());
          continue;
        }
        case 78: {
          if (tag !== 626) {
            break;
          }

          message.wsProjectAtAGlanceTab.push(reader.string());
          continue;
        }
        case 79: {
          if (tag !== 634) {
            break;
          }

          message.wsProjectSignalsTab.push(reader.string());
          continue;
        }
        case 80: {
          if (tag !== 642) {
            break;
          }

          message.wsProjectUpdates.push(reader.string());
          continue;
        }
        case 81: {
          if (tag !== 650) {
            break;
          }

          message.wsInsightCreation.push(reader.string());
          continue;
        }
        case 82: {
          if (tag !== 658) {
            break;
          }

          message.wsReporting.push(reader.string());
          continue;
        }
        case 83: {
          if (tag !== 666) {
            break;
          }

          message.wsCreateProjects.push(reader.string());
          continue;
        }
        case 84: {
          if (tag !== 674) {
            break;
          }

          message.wsHomeReportDelivery.push(reader.string());
          continue;
        }
        case 92: {
          if (tag !== 738) {
            break;
          }

          message.wsWeeklyHomeReports.push(reader.string());
          continue;
        }
        case 85: {
          if (tag !== 682) {
            break;
          }

          message.wsWeaverHome.push(reader.string());
          continue;
        }
        case 86: {
          if (tag !== 690) {
            break;
          }

          message.respectDisabledSpecs.push(reader.string());
          continue;
        }
        case 87: {
          if (tag !== 698) {
            break;
          }

          message.wsGenerativeMarkdownDirectives.push(reader.string());
          continue;
        }
        case 88: {
          if (tag !== 706) {
            break;
          }

          message.wsOnboardingFlow.push(reader.string());
          continue;
        }
        case 89: {
          if (tag !== 714) {
            break;
          }

          message.wsLegacyCompanyRoles.push(reader.string());
          continue;
        }
        case 90: {
          if (tag !== 720) {
            break;
          }

          message.openFrontDoor = reader.bool();
          continue;
        }
        case 91: {
          if (tag !== 730) {
            break;
          }

          message.wsSlackNativeDeepLinks.push(reader.string());
          continue;
        }
        case 93: {
          if (tag !== 746) {
            break;
          }

          message.wsWorkspaceMemories.push(reader.string());
          continue;
        }
        case 94: {
          if (tag !== 754) {
            break;
          }

          message.wsManagedConnections.push(reader.string());
          continue;
        }
        case 95: {
          if (tag !== 762) {
            break;
          }

          message.wsFeatureRequestInsights.push(reader.string());
          continue;
        }
        case 96: {
          if (tag !== 770) {
            break;
          }

          message.wsMcpDirectGraphQuery.push(reader.string());
          continue;
        }
        case 97: {
          if (tag !== 778) {
            break;
          }

          message.wsDashboards.push(reader.string());
          continue;
        }
        case 98: {
          if (tag !== 786) {
            break;
          }

          message.wsBillingUsage.push(reader.string());
          continue;
        }
        case 99: {
          if (tag !== 794) {
            break;
          }

          message.wsTeamsIntegration.push(reader.string());
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.wsGoals.push(reader.string());
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.wsTeams.push(reader.string());
          continue;
        }
        case 102: {
          if (tag !== 818) {
            break;
          }

          message.wsHybridEntitySearch.push(reader.string());
          continue;
        }
        case 110: {
          if (tag !== 880) {
            break;
          }

          message.plgDomainDiscovery = reader.bool();
          continue;
        }
        case 103: {
          if (tag !== 826) {
            break;
          }

          message.wsKnowledgeSearchPage.push(reader.string());
          continue;
        }
        case 104: {
          if (tag !== 834) {
            break;
          }

          message.wsInferredProjects.push(reader.string());
          continue;
        }
        case 105: {
          if (tag !== 842) {
            break;
          }

          message.wsMcpCompactResponses.push(reader.string());
          continue;
        }
        case 106: {
          if (tag !== 850) {
            break;
          }

          message.wsExternalDocuments.push(reader.string());
          continue;
        }
        case 107: {
          if (tag !== 858) {
            break;
          }

          message.wsAddCustomMcpConnections.push(reader.string());
          continue;
        }
        case 108: {
          if (tag !== 866) {
            break;
          }

          message.wsDecisionExtraction.push(reader.string());
          continue;
        }
        case 111: {
          if (tag !== 890) {
            break;
          }

          message.wsDashboardSchedules.push(reader.string());
          continue;
        }
        case 112: {
          if (tag !== 898) {
            break;
          }

          message.wsZoom.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FeatureFlags {
    return {
      enablePulse: isSet(object.enablePulse)
        ? globalThis.Boolean(object.enablePulse)
        : isSet(object.enable_pulse)
        ? globalThis.Boolean(object.enable_pulse)
        : false,
      wsWithAllowedExec: globalThis.Array.isArray(object?.wsWithAllowedExec)
        ? object.wsWithAllowedExec.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_with_allowed_exec)
        ? object.ws_with_allowed_exec.map((e: any) => globalThis.String(e))
        : [],
      enableMergeIdeas: isSet(object.enableMergeIdeas)
        ? globalThis.Boolean(object.enableMergeIdeas)
        : isSet(object.enable_merge_ideas)
        ? globalThis.Boolean(object.enable_merge_ideas)
        : false,
      wsJiraWebhook: globalThis.Array.isArray(object?.wsJiraWebhook)
        ? object.wsJiraWebhook.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_jira_webhook)
        ? object.ws_jira_webhook.map((e: any) => globalThis.String(e))
        : [],
      wsRunBlocklist: globalThis.Array.isArray(object?.wsRunBlocklist)
        ? object.wsRunBlocklist.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_run_blocklist)
        ? object.ws_run_blocklist.map((e: any) => globalThis.String(e))
        : [],
      wsProjectSummaryTab: globalThis.Array.isArray(object?.wsProjectSummaryTab)
        ? object.wsProjectSummaryTab.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_project_summary_tab)
        ? object.ws_project_summary_tab.map((e: any) => globalThis.String(e))
        : [],
      wsFeatureCatalogue: globalThis.Array.isArray(object?.wsFeatureCatalogue)
        ? object.wsFeatureCatalogue.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_feature_catalogue)
        ? object.ws_feature_catalogue.map((e: any) => globalThis.String(e))
        : [],
      wsEnableActivityCallsiteTracing: globalThis.Array.isArray(object?.wsEnableActivityCallsiteTracing)
        ? object.wsEnableActivityCallsiteTracing.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_enable_activity_callsite_tracing)
        ? object.ws_enable_activity_callsite_tracing.map((e: any) => globalThis.String(e))
        : [],
      wsCustomizableTemplates: globalThis.Array.isArray(object?.wsCustomizableTemplates)
        ? object.wsCustomizableTemplates.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_customizable_templates)
        ? object.ws_customizable_templates.map((e: any) => globalThis.String(e))
        : [],
      wsRequirementsTasksTab: globalThis.Array.isArray(object?.wsRequirementsTasksTab)
        ? object.wsRequirementsTasksTab.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_requirements_tasks_tab)
        ? object.ws_requirements_tasks_tab.map((e: any) => globalThis.String(e))
        : [],
      wsCatalogueFeatureStatus: globalThis.Array.isArray(object?.wsCatalogueFeatureStatus)
        ? object.wsCatalogueFeatureStatus.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_catalogue_feature_status)
        ? object.ws_catalogue_feature_status.map((e: any) => globalThis.String(e))
        : [],
      wsChats: globalThis.Array.isArray(object?.wsChats)
        ? object.wsChats.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_chats)
        ? object.ws_chats.map((e: any) => globalThis.String(e))
        : [],
      hidePersonalPayments: isSet(object.hidePersonalPayments)
        ? globalThis.Boolean(object.hidePersonalPayments)
        : isSet(object.hide_personal_payments)
        ? globalThis.Boolean(object.hide_personal_payments)
        : false,
      wsSlackIntegration: globalThis.Array.isArray(object?.wsSlackIntegration)
        ? object.wsSlackIntegration.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_slack_integration)
        ? object.ws_slack_integration.map((e: any) => globalThis.String(e))
        : [],
      wsTrends: globalThis.Array.isArray(object?.wsTrends)
        ? object.wsTrends.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_trends)
        ? object.ws_trends.map((e: any) => globalThis.String(e))
        : [],
      wsKnowledgeAgent: globalThis.Array.isArray(object?.wsKnowledgeAgent)
        ? object.wsKnowledgeAgent.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_knowledge_agent)
        ? object.ws_knowledge_agent.map((e: any) => globalThis.String(e))
        : [],
      wsKnowledgeRedesign: globalThis.Array.isArray(object?.wsKnowledgeRedesign)
        ? object.wsKnowledgeRedesign.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_knowledge_redesign)
        ? object.ws_knowledge_redesign.map((e: any) => globalThis.String(e))
        : [],
      wsGranola: globalThis.Array.isArray(object?.wsGranola)
        ? object.wsGranola.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_granola)
        ? object.ws_granola.map((e: any) => globalThis.String(e))
        : [],
      wsApiKeys: globalThis.Array.isArray(object?.wsApiKeys)
        ? object.wsApiKeys.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_api_keys)
        ? object.ws_api_keys.map((e: any) => globalThis.String(e))
        : [],
      wsGoogleDrive: globalThis.Array.isArray(object?.wsGoogleDrive)
        ? object.wsGoogleDrive.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_google_drive)
        ? object.ws_google_drive.map((e: any) => globalThis.String(e))
        : [],
      wsProactiveTokenRefresh: globalThis.Array.isArray(object?.wsProactiveTokenRefresh)
        ? object.wsProactiveTokenRefresh.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_proactive_token_refresh)
        ? object.ws_proactive_token_refresh.map((e: any) => globalThis.String(e))
        : [],
      wsMeetingNotes: globalThis.Array.isArray(object?.wsMeetingNotes)
        ? object.wsMeetingNotes.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_meeting_notes)
        ? object.ws_meeting_notes.map((e: any) => globalThis.String(e))
        : [],
      wsSignals: globalThis.Array.isArray(object?.wsSignals)
        ? object.wsSignals.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_signals)
        ? object.ws_signals.map((e: any) => globalThis.String(e))
        : [],
      wsBugs: globalThis.Array.isArray(object?.wsBugs)
        ? object.wsBugs.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_bugs)
        ? object.ws_bugs.map((e: any) => globalThis.String(e))
        : [],
      wsCatalogueFeedback: globalThis.Array.isArray(object?.wsCatalogueFeedback)
        ? object.wsCatalogueFeedback.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_catalogue_feedback)
        ? object.ws_catalogue_feedback.map((e: any) => globalThis.String(e))
        : [],
      wsNotion: globalThis.Array.isArray(object?.wsNotion)
        ? object.wsNotion.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_notion)
        ? object.ws_notion.map((e: any) => globalThis.String(e))
        : [],
      wsInsights: globalThis.Array.isArray(object?.wsInsights)
        ? object.wsInsights.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_insights)
        ? object.ws_insights.map((e: any) => globalThis.String(e))
        : [],
      wsIntegrationsV2: globalThis.Array.isArray(object?.wsIntegrationsV2)
        ? object.wsIntegrationsV2.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_integrations_v2)
        ? object.ws_integrations_v2.map((e: any) => globalThis.String(e))
        : [],
      wsProjectStatusTab: globalThis.Array.isArray(object?.wsProjectStatusTab)
        ? object.wsProjectStatusTab.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_project_status_tab)
        ? object.ws_project_status_tab.map((e: any) => globalThis.String(e))
        : [],
      wsProjectAtAGlanceTab: globalThis.Array.isArray(object?.wsProjectAtAGlanceTab)
        ? object.wsProjectAtAGlanceTab.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_project_at_a_glance_tab)
        ? object.ws_project_at_a_glance_tab.map((e: any) => globalThis.String(e))
        : [],
      wsProjectSignalsTab: globalThis.Array.isArray(object?.wsProjectSignalsTab)
        ? object.wsProjectSignalsTab.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_project_signals_tab)
        ? object.ws_project_signals_tab.map((e: any) => globalThis.String(e))
        : [],
      wsProjectUpdates: globalThis.Array.isArray(object?.wsProjectUpdates)
        ? object.wsProjectUpdates.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_project_updates)
        ? object.ws_project_updates.map((e: any) => globalThis.String(e))
        : [],
      wsInsightCreation: globalThis.Array.isArray(object?.wsInsightCreation)
        ? object.wsInsightCreation.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_insight_creation)
        ? object.ws_insight_creation.map((e: any) => globalThis.String(e))
        : [],
      wsReporting: globalThis.Array.isArray(object?.wsReporting)
        ? object.wsReporting.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_reporting)
        ? object.ws_reporting.map((e: any) => globalThis.String(e))
        : [],
      wsCreateProjects: globalThis.Array.isArray(object?.wsCreateProjects)
        ? object.wsCreateProjects.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_create_projects)
        ? object.ws_create_projects.map((e: any) => globalThis.String(e))
        : [],
      wsHomeReportDelivery: globalThis.Array.isArray(object?.wsHomeReportDelivery)
        ? object.wsHomeReportDelivery.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_home_report_delivery)
        ? object.ws_home_report_delivery.map((e: any) => globalThis.String(e))
        : [],
      wsWeeklyHomeReports: globalThis.Array.isArray(object?.wsWeeklyHomeReports)
        ? object.wsWeeklyHomeReports.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_weekly_home_reports)
        ? object.ws_weekly_home_reports.map((e: any) => globalThis.String(e))
        : [],
      wsWeaverHome: globalThis.Array.isArray(object?.wsWeaverHome)
        ? object.wsWeaverHome.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_weaver_home)
        ? object.ws_weaver_home.map((e: any) => globalThis.String(e))
        : [],
      respectDisabledSpecs: globalThis.Array.isArray(object?.respectDisabledSpecs)
        ? object.respectDisabledSpecs.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.respect_disabled_specs)
        ? object.respect_disabled_specs.map((e: any) => globalThis.String(e))
        : [],
      wsGenerativeMarkdownDirectives: globalThis.Array.isArray(object?.wsGenerativeMarkdownDirectives)
        ? object.wsGenerativeMarkdownDirectives.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_generative_markdown_directives)
        ? object.ws_generative_markdown_directives.map((e: any) => globalThis.String(e))
        : [],
      wsOnboardingFlow: globalThis.Array.isArray(object?.wsOnboardingFlow)
        ? object.wsOnboardingFlow.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_onboarding_flow)
        ? object.ws_onboarding_flow.map((e: any) => globalThis.String(e))
        : [],
      wsLegacyCompanyRoles: globalThis.Array.isArray(object?.wsLegacyCompanyRoles)
        ? object.wsLegacyCompanyRoles.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_legacy_company_roles)
        ? object.ws_legacy_company_roles.map((e: any) => globalThis.String(e))
        : [],
      openFrontDoor: isSet(object.openFrontDoor)
        ? globalThis.Boolean(object.openFrontDoor)
        : isSet(object.open_front_door)
        ? globalThis.Boolean(object.open_front_door)
        : false,
      wsSlackNativeDeepLinks: globalThis.Array.isArray(object?.wsSlackNativeDeepLinks)
        ? object.wsSlackNativeDeepLinks.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_slack_native_deep_links)
        ? object.ws_slack_native_deep_links.map((e: any) => globalThis.String(e))
        : [],
      wsWorkspaceMemories: globalThis.Array.isArray(object?.wsWorkspaceMemories)
        ? object.wsWorkspaceMemories.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_workspace_memories)
        ? object.ws_workspace_memories.map((e: any) => globalThis.String(e))
        : [],
      wsManagedConnections: globalThis.Array.isArray(object?.wsManagedConnections)
        ? object.wsManagedConnections.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_managed_connections)
        ? object.ws_managed_connections.map((e: any) => globalThis.String(e))
        : [],
      wsFeatureRequestInsights: globalThis.Array.isArray(object?.wsFeatureRequestInsights)
        ? object.wsFeatureRequestInsights.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_feature_request_insights)
        ? object.ws_feature_request_insights.map((e: any) => globalThis.String(e))
        : [],
      wsMcpDirectGraphQuery: globalThis.Array.isArray(object?.wsMcpDirectGraphQuery)
        ? object.wsMcpDirectGraphQuery.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_mcp_direct_graph_query)
        ? object.ws_mcp_direct_graph_query.map((e: any) => globalThis.String(e))
        : [],
      wsDashboards: globalThis.Array.isArray(object?.wsDashboards)
        ? object.wsDashboards.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_dashboards)
        ? object.ws_dashboards.map((e: any) => globalThis.String(e))
        : [],
      wsBillingUsage: globalThis.Array.isArray(object?.wsBillingUsage)
        ? object.wsBillingUsage.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_billing_usage)
        ? object.ws_billing_usage.map((e: any) => globalThis.String(e))
        : [],
      wsTeamsIntegration: globalThis.Array.isArray(object?.wsTeamsIntegration)
        ? object.wsTeamsIntegration.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_teams_integration)
        ? object.ws_teams_integration.map((e: any) => globalThis.String(e))
        : [],
      wsGoals: globalThis.Array.isArray(object?.wsGoals)
        ? object.wsGoals.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_goals)
        ? object.ws_goals.map((e: any) => globalThis.String(e))
        : [],
      wsTeams: globalThis.Array.isArray(object?.wsTeams)
        ? object.wsTeams.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_teams)
        ? object.ws_teams.map((e: any) => globalThis.String(e))
        : [],
      wsHybridEntitySearch: globalThis.Array.isArray(object?.wsHybridEntitySearch)
        ? object.wsHybridEntitySearch.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_hybrid_entity_search)
        ? object.ws_hybrid_entity_search.map((e: any) => globalThis.String(e))
        : [],
      plgDomainDiscovery: isSet(object.plgDomainDiscovery)
        ? globalThis.Boolean(object.plgDomainDiscovery)
        : isSet(object.plg_domain_discovery)
        ? globalThis.Boolean(object.plg_domain_discovery)
        : false,
      wsKnowledgeSearchPage: globalThis.Array.isArray(object?.wsKnowledgeSearchPage)
        ? object.wsKnowledgeSearchPage.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_knowledge_search_page)
        ? object.ws_knowledge_search_page.map((e: any) => globalThis.String(e))
        : [],
      wsInferredProjects: globalThis.Array.isArray(object?.wsInferredProjects)
        ? object.wsInferredProjects.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_inferred_projects)
        ? object.ws_inferred_projects.map((e: any) => globalThis.String(e))
        : [],
      wsMcpCompactResponses: globalThis.Array.isArray(object?.wsMcpCompactResponses)
        ? object.wsMcpCompactResponses.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_mcp_compact_responses)
        ? object.ws_mcp_compact_responses.map((e: any) => globalThis.String(e))
        : [],
      wsExternalDocuments: globalThis.Array.isArray(object?.wsExternalDocuments)
        ? object.wsExternalDocuments.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_external_documents)
        ? object.ws_external_documents.map((e: any) => globalThis.String(e))
        : [],
      wsAddCustomMcpConnections: globalThis.Array.isArray(object?.wsAddCustomMcpConnections)
        ? object.wsAddCustomMcpConnections.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_add_custom_mcp_connections)
        ? object.ws_add_custom_mcp_connections.map((e: any) => globalThis.String(e))
        : [],
      wsDecisionExtraction: globalThis.Array.isArray(object?.wsDecisionExtraction)
        ? object.wsDecisionExtraction.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_decision_extraction)
        ? object.ws_decision_extraction.map((e: any) => globalThis.String(e))
        : [],
      wsDashboardSchedules: globalThis.Array.isArray(object?.wsDashboardSchedules)
        ? object.wsDashboardSchedules.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_dashboard_schedules)
        ? object.ws_dashboard_schedules.map((e: any) => globalThis.String(e))
        : [],
      wsZoom: globalThis.Array.isArray(object?.wsZoom)
        ? object.wsZoom.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ws_zoom)
        ? object.ws_zoom.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: FeatureFlags): unknown {
    const obj: any = {};
    if (message.enablePulse !== false) {
      obj.enablePulse = message.enablePulse;
    }
    if (message.wsWithAllowedExec?.length) {
      obj.wsWithAllowedExec = message.wsWithAllowedExec;
    }
    if (message.enableMergeIdeas !== false) {
      obj.enableMergeIdeas = message.enableMergeIdeas;
    }
    if (message.wsJiraWebhook?.length) {
      obj.wsJiraWebhook = message.wsJiraWebhook;
    }
    if (message.wsRunBlocklist?.length) {
      obj.wsRunBlocklist = message.wsRunBlocklist;
    }
    if (message.wsProjectSummaryTab?.length) {
      obj.wsProjectSummaryTab = message.wsProjectSummaryTab;
    }
    if (message.wsFeatureCatalogue?.length) {
      obj.wsFeatureCatalogue = message.wsFeatureCatalogue;
    }
    if (message.wsEnableActivityCallsiteTracing?.length) {
      obj.wsEnableActivityCallsiteTracing = message.wsEnableActivityCallsiteTracing;
    }
    if (message.wsCustomizableTemplates?.length) {
      obj.wsCustomizableTemplates = message.wsCustomizableTemplates;
    }
    if (message.wsRequirementsTasksTab?.length) {
      obj.wsRequirementsTasksTab = message.wsRequirementsTasksTab;
    }
    if (message.wsCatalogueFeatureStatus?.length) {
      obj.wsCatalogueFeatureStatus = message.wsCatalogueFeatureStatus;
    }
    if (message.wsChats?.length) {
      obj.wsChats = message.wsChats;
    }
    if (message.hidePersonalPayments !== false) {
      obj.hidePersonalPayments = message.hidePersonalPayments;
    }
    if (message.wsSlackIntegration?.length) {
      obj.wsSlackIntegration = message.wsSlackIntegration;
    }
    if (message.wsTrends?.length) {
      obj.wsTrends = message.wsTrends;
    }
    if (message.wsKnowledgeAgent?.length) {
      obj.wsKnowledgeAgent = message.wsKnowledgeAgent;
    }
    if (message.wsKnowledgeRedesign?.length) {
      obj.wsKnowledgeRedesign = message.wsKnowledgeRedesign;
    }
    if (message.wsGranola?.length) {
      obj.wsGranola = message.wsGranola;
    }
    if (message.wsApiKeys?.length) {
      obj.wsApiKeys = message.wsApiKeys;
    }
    if (message.wsGoogleDrive?.length) {
      obj.wsGoogleDrive = message.wsGoogleDrive;
    }
    if (message.wsProactiveTokenRefresh?.length) {
      obj.wsProactiveTokenRefresh = message.wsProactiveTokenRefresh;
    }
    if (message.wsMeetingNotes?.length) {
      obj.wsMeetingNotes = message.wsMeetingNotes;
    }
    if (message.wsSignals?.length) {
      obj.wsSignals = message.wsSignals;
    }
    if (message.wsBugs?.length) {
      obj.wsBugs = message.wsBugs;
    }
    if (message.wsCatalogueFeedback?.length) {
      obj.wsCatalogueFeedback = message.wsCatalogueFeedback;
    }
    if (message.wsNotion?.length) {
      obj.wsNotion = message.wsNotion;
    }
    if (message.wsInsights?.length) {
      obj.wsInsights = message.wsInsights;
    }
    if (message.wsIntegrationsV2?.length) {
      obj.wsIntegrationsV2 = message.wsIntegrationsV2;
    }
    if (message.wsProjectStatusTab?.length) {
      obj.wsProjectStatusTab = message.wsProjectStatusTab;
    }
    if (message.wsProjectAtAGlanceTab?.length) {
      obj.wsProjectAtAGlanceTab = message.wsProjectAtAGlanceTab;
    }
    if (message.wsProjectSignalsTab?.length) {
      obj.wsProjectSignalsTab = message.wsProjectSignalsTab;
    }
    if (message.wsProjectUpdates?.length) {
      obj.wsProjectUpdates = message.wsProjectUpdates;
    }
    if (message.wsInsightCreation?.length) {
      obj.wsInsightCreation = message.wsInsightCreation;
    }
    if (message.wsReporting?.length) {
      obj.wsReporting = message.wsReporting;
    }
    if (message.wsCreateProjects?.length) {
      obj.wsCreateProjects = message.wsCreateProjects;
    }
    if (message.wsHomeReportDelivery?.length) {
      obj.wsHomeReportDelivery = message.wsHomeReportDelivery;
    }
    if (message.wsWeeklyHomeReports?.length) {
      obj.wsWeeklyHomeReports = message.wsWeeklyHomeReports;
    }
    if (message.wsWeaverHome?.length) {
      obj.wsWeaverHome = message.wsWeaverHome;
    }
    if (message.respectDisabledSpecs?.length) {
      obj.respectDisabledSpecs = message.respectDisabledSpecs;
    }
    if (message.wsGenerativeMarkdownDirectives?.length) {
      obj.wsGenerativeMarkdownDirectives = message.wsGenerativeMarkdownDirectives;
    }
    if (message.wsOnboardingFlow?.length) {
      obj.wsOnboardingFlow = message.wsOnboardingFlow;
    }
    if (message.wsLegacyCompanyRoles?.length) {
      obj.wsLegacyCompanyRoles = message.wsLegacyCompanyRoles;
    }
    if (message.openFrontDoor !== false) {
      obj.openFrontDoor = message.openFrontDoor;
    }
    if (message.wsSlackNativeDeepLinks?.length) {
      obj.wsSlackNativeDeepLinks = message.wsSlackNativeDeepLinks;
    }
    if (message.wsWorkspaceMemories?.length) {
      obj.wsWorkspaceMemories = message.wsWorkspaceMemories;
    }
    if (message.wsManagedConnections?.length) {
      obj.wsManagedConnections = message.wsManagedConnections;
    }
    if (message.wsFeatureRequestInsights?.length) {
      obj.wsFeatureRequestInsights = message.wsFeatureRequestInsights;
    }
    if (message.wsMcpDirectGraphQuery?.length) {
      obj.wsMcpDirectGraphQuery = message.wsMcpDirectGraphQuery;
    }
    if (message.wsDashboards?.length) {
      obj.wsDashboards = message.wsDashboards;
    }
    if (message.wsBillingUsage?.length) {
      obj.wsBillingUsage = message.wsBillingUsage;
    }
    if (message.wsTeamsIntegration?.length) {
      obj.wsTeamsIntegration = message.wsTeamsIntegration;
    }
    if (message.wsGoals?.length) {
      obj.wsGoals = message.wsGoals;
    }
    if (message.wsTeams?.length) {
      obj.wsTeams = message.wsTeams;
    }
    if (message.wsHybridEntitySearch?.length) {
      obj.wsHybridEntitySearch = message.wsHybridEntitySearch;
    }
    if (message.plgDomainDiscovery !== false) {
      obj.plgDomainDiscovery = message.plgDomainDiscovery;
    }
    if (message.wsKnowledgeSearchPage?.length) {
      obj.wsKnowledgeSearchPage = message.wsKnowledgeSearchPage;
    }
    if (message.wsInferredProjects?.length) {
      obj.wsInferredProjects = message.wsInferredProjects;
    }
    if (message.wsMcpCompactResponses?.length) {
      obj.wsMcpCompactResponses = message.wsMcpCompactResponses;
    }
    if (message.wsExternalDocuments?.length) {
      obj.wsExternalDocuments = message.wsExternalDocuments;
    }
    if (message.wsAddCustomMcpConnections?.length) {
      obj.wsAddCustomMcpConnections = message.wsAddCustomMcpConnections;
    }
    if (message.wsDecisionExtraction?.length) {
      obj.wsDecisionExtraction = message.wsDecisionExtraction;
    }
    if (message.wsDashboardSchedules?.length) {
      obj.wsDashboardSchedules = message.wsDashboardSchedules;
    }
    if (message.wsZoom?.length) {
      obj.wsZoom = message.wsZoom;
    }
    return obj;
  },

  create(base?: DeepPartial<FeatureFlags>): FeatureFlags {
    return FeatureFlags.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FeatureFlags>): FeatureFlags {
    const message = createBaseFeatureFlags();
    message.enablePulse = object.enablePulse ?? false;
    message.wsWithAllowedExec = object.wsWithAllowedExec?.map((e) => e) || [];
    message.enableMergeIdeas = object.enableMergeIdeas ?? false;
    message.wsJiraWebhook = object.wsJiraWebhook?.map((e) => e) || [];
    message.wsRunBlocklist = object.wsRunBlocklist?.map((e) => e) || [];
    message.wsProjectSummaryTab = object.wsProjectSummaryTab?.map((e) => e) || [];
    message.wsFeatureCatalogue = object.wsFeatureCatalogue?.map((e) => e) || [];
    message.wsEnableActivityCallsiteTracing = object.wsEnableActivityCallsiteTracing?.map((e) => e) || [];
    message.wsCustomizableTemplates = object.wsCustomizableTemplates?.map((e) => e) || [];
    message.wsRequirementsTasksTab = object.wsRequirementsTasksTab?.map((e) => e) || [];
    message.wsCatalogueFeatureStatus = object.wsCatalogueFeatureStatus?.map((e) => e) || [];
    message.wsChats = object.wsChats?.map((e) => e) || [];
    message.hidePersonalPayments = object.hidePersonalPayments ?? false;
    message.wsSlackIntegration = object.wsSlackIntegration?.map((e) => e) || [];
    message.wsTrends = object.wsTrends?.map((e) => e) || [];
    message.wsKnowledgeAgent = object.wsKnowledgeAgent?.map((e) => e) || [];
    message.wsKnowledgeRedesign = object.wsKnowledgeRedesign?.map((e) => e) || [];
    message.wsGranola = object.wsGranola?.map((e) => e) || [];
    message.wsApiKeys = object.wsApiKeys?.map((e) => e) || [];
    message.wsGoogleDrive = object.wsGoogleDrive?.map((e) => e) || [];
    message.wsProactiveTokenRefresh = object.wsProactiveTokenRefresh?.map((e) => e) || [];
    message.wsMeetingNotes = object.wsMeetingNotes?.map((e) => e) || [];
    message.wsSignals = object.wsSignals?.map((e) => e) || [];
    message.wsBugs = object.wsBugs?.map((e) => e) || [];
    message.wsCatalogueFeedback = object.wsCatalogueFeedback?.map((e) => e) || [];
    message.wsNotion = object.wsNotion?.map((e) => e) || [];
    message.wsInsights = object.wsInsights?.map((e) => e) || [];
    message.wsIntegrationsV2 = object.wsIntegrationsV2?.map((e) => e) || [];
    message.wsProjectStatusTab = object.wsProjectStatusTab?.map((e) => e) || [];
    message.wsProjectAtAGlanceTab = object.wsProjectAtAGlanceTab?.map((e) => e) || [];
    message.wsProjectSignalsTab = object.wsProjectSignalsTab?.map((e) => e) || [];
    message.wsProjectUpdates = object.wsProjectUpdates?.map((e) => e) || [];
    message.wsInsightCreation = object.wsInsightCreation?.map((e) => e) || [];
    message.wsReporting = object.wsReporting?.map((e) => e) || [];
    message.wsCreateProjects = object.wsCreateProjects?.map((e) => e) || [];
    message.wsHomeReportDelivery = object.wsHomeReportDelivery?.map((e) => e) || [];
    message.wsWeeklyHomeReports = object.wsWeeklyHomeReports?.map((e) => e) || [];
    message.wsWeaverHome = object.wsWeaverHome?.map((e) => e) || [];
    message.respectDisabledSpecs = object.respectDisabledSpecs?.map((e) => e) || [];
    message.wsGenerativeMarkdownDirectives = object.wsGenerativeMarkdownDirectives?.map((e) => e) || [];
    message.wsOnboardingFlow = object.wsOnboardingFlow?.map((e) => e) || [];
    message.wsLegacyCompanyRoles = object.wsLegacyCompanyRoles?.map((e) => e) || [];
    message.openFrontDoor = object.openFrontDoor ?? false;
    message.wsSlackNativeDeepLinks = object.wsSlackNativeDeepLinks?.map((e) => e) || [];
    message.wsWorkspaceMemories = object.wsWorkspaceMemories?.map((e) => e) || [];
    message.wsManagedConnections = object.wsManagedConnections?.map((e) => e) || [];
    message.wsFeatureRequestInsights = object.wsFeatureRequestInsights?.map((e) => e) || [];
    message.wsMcpDirectGraphQuery = object.wsMcpDirectGraphQuery?.map((e) => e) || [];
    message.wsDashboards = object.wsDashboards?.map((e) => e) || [];
    message.wsBillingUsage = object.wsBillingUsage?.map((e) => e) || [];
    message.wsTeamsIntegration = object.wsTeamsIntegration?.map((e) => e) || [];
    message.wsGoals = object.wsGoals?.map((e) => e) || [];
    message.wsTeams = object.wsTeams?.map((e) => e) || [];
    message.wsHybridEntitySearch = object.wsHybridEntitySearch?.map((e) => e) || [];
    message.plgDomainDiscovery = object.plgDomainDiscovery ?? false;
    message.wsKnowledgeSearchPage = object.wsKnowledgeSearchPage?.map((e) => e) || [];
    message.wsInferredProjects = object.wsInferredProjects?.map((e) => e) || [];
    message.wsMcpCompactResponses = object.wsMcpCompactResponses?.map((e) => e) || [];
    message.wsExternalDocuments = object.wsExternalDocuments?.map((e) => e) || [];
    message.wsAddCustomMcpConnections = object.wsAddCustomMcpConnections?.map((e) => e) || [];
    message.wsDecisionExtraction = object.wsDecisionExtraction?.map((e) => e) || [];
    message.wsDashboardSchedules = object.wsDashboardSchedules?.map((e) => e) || [];
    message.wsZoom = object.wsZoom?.map((e) => e) || [];
    return message;
  },
};

function createBaseRepoAnalysisConfig(): RepoAnalysisConfig {
  return { flatten: undefined, analysis: undefined, processingIntervals: undefined };
}

export const RepoAnalysisConfig: MessageFns<RepoAnalysisConfig> = {
  encode(message: RepoAnalysisConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flatten !== undefined) {
      RepoAnalysisConfig_Flatten.encode(message.flatten, writer.uint32(10).fork()).join();
    }
    if (message.analysis !== undefined) {
      RepoAnalysisConfig_Analysis.encode(message.analysis, writer.uint32(18).fork()).join();
    }
    if (message.processingIntervals !== undefined) {
      RepoAnalysisConfig_Intervals.encode(message.processingIntervals, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RepoAnalysisConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepoAnalysisConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.flatten = RepoAnalysisConfig_Flatten.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.analysis = RepoAnalysisConfig_Analysis.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.processingIntervals = RepoAnalysisConfig_Intervals.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RepoAnalysisConfig {
    return {
      flatten: isSet(object.flatten) ? RepoAnalysisConfig_Flatten.fromJSON(object.flatten) : undefined,
      analysis: isSet(object.analysis) ? RepoAnalysisConfig_Analysis.fromJSON(object.analysis) : undefined,
      processingIntervals: isSet(object.processingIntervals)
        ? RepoAnalysisConfig_Intervals.fromJSON(object.processingIntervals)
        : isSet(object.processing_intervals)
        ? RepoAnalysisConfig_Intervals.fromJSON(object.processing_intervals)
        : undefined,
    };
  },

  toJSON(message: RepoAnalysisConfig): unknown {
    const obj: any = {};
    if (message.flatten !== undefined) {
      obj.flatten = RepoAnalysisConfig_Flatten.toJSON(message.flatten);
    }
    if (message.analysis !== undefined) {
      obj.analysis = RepoAnalysisConfig_Analysis.toJSON(message.analysis);
    }
    if (message.processingIntervals !== undefined) {
      obj.processingIntervals = RepoAnalysisConfig_Intervals.toJSON(message.processingIntervals);
    }
    return obj;
  },

  create(base?: DeepPartial<RepoAnalysisConfig>): RepoAnalysisConfig {
    return RepoAnalysisConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RepoAnalysisConfig>): RepoAnalysisConfig {
    const message = createBaseRepoAnalysisConfig();
    message.flatten = (object.flatten !== undefined && object.flatten !== null)
      ? RepoAnalysisConfig_Flatten.fromPartial(object.flatten)
      : undefined;
    message.analysis = (object.analysis !== undefined && object.analysis !== null)
      ? RepoAnalysisConfig_Analysis.fromPartial(object.analysis)
      : undefined;
    message.processingIntervals = (object.processingIntervals !== undefined && object.processingIntervals !== null)
      ? RepoAnalysisConfig_Intervals.fromPartial(object.processingIntervals)
      : undefined;
    return message;
  },
};

function createBaseRepoAnalysisConfig_Intervals(): RepoAnalysisConfig_Intervals {
  return { disabled: false, integrationSec: 0, reposSec: 0 };
}

export const RepoAnalysisConfig_Intervals: MessageFns<RepoAnalysisConfig_Intervals> = {
  encode(message: RepoAnalysisConfig_Intervals, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.disabled !== false) {
      writer.uint32(8).bool(message.disabled);
    }
    if (message.integrationSec !== 0) {
      writer.uint32(16).int32(message.integrationSec);
    }
    if (message.reposSec !== 0) {
      writer.uint32(24).int32(message.reposSec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RepoAnalysisConfig_Intervals {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepoAnalysisConfig_Intervals();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.disabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.integrationSec = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.reposSec = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RepoAnalysisConfig_Intervals {
    return {
      disabled: isSet(object.disabled) ? globalThis.Boolean(object.disabled) : false,
      integrationSec: isSet(object.integrationSec)
        ? globalThis.Number(object.integrationSec)
        : isSet(object.integration_sec)
        ? globalThis.Number(object.integration_sec)
        : 0,
      reposSec: isSet(object.reposSec)
        ? globalThis.Number(object.reposSec)
        : isSet(object.repos_sec)
        ? globalThis.Number(object.repos_sec)
        : 0,
    };
  },

  toJSON(message: RepoAnalysisConfig_Intervals): unknown {
    const obj: any = {};
    if (message.disabled !== false) {
      obj.disabled = message.disabled;
    }
    if (message.integrationSec !== 0) {
      obj.integrationSec = Math.round(message.integrationSec);
    }
    if (message.reposSec !== 0) {
      obj.reposSec = Math.round(message.reposSec);
    }
    return obj;
  },

  create(base?: DeepPartial<RepoAnalysisConfig_Intervals>): RepoAnalysisConfig_Intervals {
    return RepoAnalysisConfig_Intervals.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RepoAnalysisConfig_Intervals>): RepoAnalysisConfig_Intervals {
    const message = createBaseRepoAnalysisConfig_Intervals();
    message.disabled = object.disabled ?? false;
    message.integrationSec = object.integrationSec ?? 0;
    message.reposSec = object.reposSec ?? 0;
    return message;
  },
};

function createBaseRepoAnalysisConfig_Analysis(): RepoAnalysisConfig_Analysis {
  return { model: undefined };
}

export const RepoAnalysisConfig_Analysis: MessageFns<RepoAnalysisConfig_Analysis> = {
  encode(message: RepoAnalysisConfig_Analysis, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.model !== undefined) {
      ModelConfig.encode(message.model, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RepoAnalysisConfig_Analysis {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepoAnalysisConfig_Analysis();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.model = ModelConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RepoAnalysisConfig_Analysis {
    return { model: isSet(object.model) ? ModelConfig.fromJSON(object.model) : undefined };
  },

  toJSON(message: RepoAnalysisConfig_Analysis): unknown {
    const obj: any = {};
    if (message.model !== undefined) {
      obj.model = ModelConfig.toJSON(message.model);
    }
    return obj;
  },

  create(base?: DeepPartial<RepoAnalysisConfig_Analysis>): RepoAnalysisConfig_Analysis {
    return RepoAnalysisConfig_Analysis.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RepoAnalysisConfig_Analysis>): RepoAnalysisConfig_Analysis {
    const message = createBaseRepoAnalysisConfig_Analysis();
    message.model = (object.model !== undefined && object.model !== null)
      ? ModelConfig.fromPartial(object.model)
      : undefined;
    return message;
  },
};

function createBaseRepoAnalysisConfig_Flatten(): RepoAnalysisConfig_Flatten {
  return {
    compress: false,
    removeEmptyLines: false,
    outStyle: "",
    maxTokensPerChunk: 0,
    maxRepoSizeMb: 0,
    ignorePattern: undefined,
    largeRepoThresholdMb: 0,
    largeRepoIgnorePattern: undefined,
    compressLarge: false,
  };
}

export const RepoAnalysisConfig_Flatten: MessageFns<RepoAnalysisConfig_Flatten> = {
  encode(message: RepoAnalysisConfig_Flatten, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.compress !== false) {
      writer.uint32(8).bool(message.compress);
    }
    if (message.removeEmptyLines !== false) {
      writer.uint32(16).bool(message.removeEmptyLines);
    }
    if (message.outStyle !== "") {
      writer.uint32(26).string(message.outStyle);
    }
    if (message.maxTokensPerChunk !== 0) {
      writer.uint32(32).int32(message.maxTokensPerChunk);
    }
    if (message.maxRepoSizeMb !== 0) {
      writer.uint32(40).int32(message.maxRepoSizeMb);
    }
    if (message.ignorePattern !== undefined) {
      writer.uint32(50).string(message.ignorePattern);
    }
    if (message.largeRepoThresholdMb !== 0) {
      writer.uint32(56).int32(message.largeRepoThresholdMb);
    }
    if (message.largeRepoIgnorePattern !== undefined) {
      writer.uint32(66).string(message.largeRepoIgnorePattern);
    }
    if (message.compressLarge !== false) {
      writer.uint32(72).bool(message.compressLarge);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RepoAnalysisConfig_Flatten {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepoAnalysisConfig_Flatten();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.compress = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.removeEmptyLines = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.outStyle = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.maxTokensPerChunk = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.maxRepoSizeMb = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ignorePattern = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.largeRepoThresholdMb = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.largeRepoIgnorePattern = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.compressLarge = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RepoAnalysisConfig_Flatten {
    return {
      compress: isSet(object.compress) ? globalThis.Boolean(object.compress) : false,
      removeEmptyLines: isSet(object.removeEmptyLines)
        ? globalThis.Boolean(object.removeEmptyLines)
        : isSet(object.remove_empty_lines)
        ? globalThis.Boolean(object.remove_empty_lines)
        : false,
      outStyle: isSet(object.outStyle)
        ? globalThis.String(object.outStyle)
        : isSet(object.out_style)
        ? globalThis.String(object.out_style)
        : "",
      maxTokensPerChunk: isSet(object.maxTokensPerChunk)
        ? globalThis.Number(object.maxTokensPerChunk)
        : isSet(object.max_tokens_per_chunk)
        ? globalThis.Number(object.max_tokens_per_chunk)
        : 0,
      maxRepoSizeMb: isSet(object.maxRepoSizeMb)
        ? globalThis.Number(object.maxRepoSizeMb)
        : isSet(object.max_repo_size_mb)
        ? globalThis.Number(object.max_repo_size_mb)
        : 0,
      ignorePattern: isSet(object.ignorePattern)
        ? globalThis.String(object.ignorePattern)
        : isSet(object.ignore_pattern)
        ? globalThis.String(object.ignore_pattern)
        : undefined,
      largeRepoThresholdMb: isSet(object.largeRepoThresholdMb)
        ? globalThis.Number(object.largeRepoThresholdMb)
        : isSet(object.large_repo_threshold_mb)
        ? globalThis.Number(object.large_repo_threshold_mb)
        : 0,
      largeRepoIgnorePattern: isSet(object.largeRepoIgnorePattern)
        ? globalThis.String(object.largeRepoIgnorePattern)
        : isSet(object.large_repo_ignore_pattern)
        ? globalThis.String(object.large_repo_ignore_pattern)
        : undefined,
      compressLarge: isSet(object.compressLarge)
        ? globalThis.Boolean(object.compressLarge)
        : isSet(object.compress_large)
        ? globalThis.Boolean(object.compress_large)
        : false,
    };
  },

  toJSON(message: RepoAnalysisConfig_Flatten): unknown {
    const obj: any = {};
    if (message.compress !== false) {
      obj.compress = message.compress;
    }
    if (message.removeEmptyLines !== false) {
      obj.removeEmptyLines = message.removeEmptyLines;
    }
    if (message.outStyle !== "") {
      obj.outStyle = message.outStyle;
    }
    if (message.maxTokensPerChunk !== 0) {
      obj.maxTokensPerChunk = Math.round(message.maxTokensPerChunk);
    }
    if (message.maxRepoSizeMb !== 0) {
      obj.maxRepoSizeMb = Math.round(message.maxRepoSizeMb);
    }
    if (message.ignorePattern !== undefined) {
      obj.ignorePattern = message.ignorePattern;
    }
    if (message.largeRepoThresholdMb !== 0) {
      obj.largeRepoThresholdMb = Math.round(message.largeRepoThresholdMb);
    }
    if (message.largeRepoIgnorePattern !== undefined) {
      obj.largeRepoIgnorePattern = message.largeRepoIgnorePattern;
    }
    if (message.compressLarge !== false) {
      obj.compressLarge = message.compressLarge;
    }
    return obj;
  },

  create(base?: DeepPartial<RepoAnalysisConfig_Flatten>): RepoAnalysisConfig_Flatten {
    return RepoAnalysisConfig_Flatten.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RepoAnalysisConfig_Flatten>): RepoAnalysisConfig_Flatten {
    const message = createBaseRepoAnalysisConfig_Flatten();
    message.compress = object.compress ?? false;
    message.removeEmptyLines = object.removeEmptyLines ?? false;
    message.outStyle = object.outStyle ?? "";
    message.maxTokensPerChunk = object.maxTokensPerChunk ?? 0;
    message.maxRepoSizeMb = object.maxRepoSizeMb ?? 0;
    message.ignorePattern = object.ignorePattern ?? undefined;
    message.largeRepoThresholdMb = object.largeRepoThresholdMb ?? 0;
    message.largeRepoIgnorePattern = object.largeRepoIgnorePattern ?? undefined;
    message.compressLarge = object.compressLarge ?? false;
    return message;
  },
};

function createBaseAgentsConfig(): AgentsConfig {
  return {
    parallelPrompts: 0,
    disableLangfuseTracing: false,
    disableUsageTraces: false,
    attachmentProcessing: undefined,
    contextCompaction: undefined,
  };
}

export const AgentsConfig: MessageFns<AgentsConfig> = {
  encode(message: AgentsConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.parallelPrompts !== 0) {
      writer.uint32(8).int32(message.parallelPrompts);
    }
    if (message.disableLangfuseTracing !== false) {
      writer.uint32(16).bool(message.disableLangfuseTracing);
    }
    if (message.disableUsageTraces !== false) {
      writer.uint32(24).bool(message.disableUsageTraces);
    }
    if (message.attachmentProcessing !== undefined) {
      AttachmentProcessingConfig.encode(message.attachmentProcessing, writer.uint32(34).fork()).join();
    }
    if (message.contextCompaction !== undefined) {
      ContextCompactionConfig.encode(message.contextCompaction, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AgentsConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgentsConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.parallelPrompts = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.disableLangfuseTracing = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.disableUsageTraces = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.attachmentProcessing = AttachmentProcessingConfig.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.contextCompaction = ContextCompactionConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgentsConfig {
    return {
      parallelPrompts: isSet(object.parallelPrompts)
        ? globalThis.Number(object.parallelPrompts)
        : isSet(object.parallel_prompts)
        ? globalThis.Number(object.parallel_prompts)
        : 0,
      disableLangfuseTracing: isSet(object.disableLangfuseTracing)
        ? globalThis.Boolean(object.disableLangfuseTracing)
        : isSet(object.disable_langfuse_tracing)
        ? globalThis.Boolean(object.disable_langfuse_tracing)
        : false,
      disableUsageTraces: isSet(object.disableUsageTraces)
        ? globalThis.Boolean(object.disableUsageTraces)
        : isSet(object.disable_usage_traces)
        ? globalThis.Boolean(object.disable_usage_traces)
        : false,
      attachmentProcessing: isSet(object.attachmentProcessing)
        ? AttachmentProcessingConfig.fromJSON(object.attachmentProcessing)
        : isSet(object.attachment_processing)
        ? AttachmentProcessingConfig.fromJSON(object.attachment_processing)
        : undefined,
      contextCompaction: isSet(object.contextCompaction)
        ? ContextCompactionConfig.fromJSON(object.contextCompaction)
        : isSet(object.context_compaction)
        ? ContextCompactionConfig.fromJSON(object.context_compaction)
        : undefined,
    };
  },

  toJSON(message: AgentsConfig): unknown {
    const obj: any = {};
    if (message.parallelPrompts !== 0) {
      obj.parallelPrompts = Math.round(message.parallelPrompts);
    }
    if (message.disableLangfuseTracing !== false) {
      obj.disableLangfuseTracing = message.disableLangfuseTracing;
    }
    if (message.disableUsageTraces !== false) {
      obj.disableUsageTraces = message.disableUsageTraces;
    }
    if (message.attachmentProcessing !== undefined) {
      obj.attachmentProcessing = AttachmentProcessingConfig.toJSON(message.attachmentProcessing);
    }
    if (message.contextCompaction !== undefined) {
      obj.contextCompaction = ContextCompactionConfig.toJSON(message.contextCompaction);
    }
    return obj;
  },

  create(base?: DeepPartial<AgentsConfig>): AgentsConfig {
    return AgentsConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AgentsConfig>): AgentsConfig {
    const message = createBaseAgentsConfig();
    message.parallelPrompts = object.parallelPrompts ?? 0;
    message.disableLangfuseTracing = object.disableLangfuseTracing ?? false;
    message.disableUsageTraces = object.disableUsageTraces ?? false;
    message.attachmentProcessing = (object.attachmentProcessing !== undefined && object.attachmentProcessing !== null)
      ? AttachmentProcessingConfig.fromPartial(object.attachmentProcessing)
      : undefined;
    message.contextCompaction = (object.contextCompaction !== undefined && object.contextCompaction !== null)
      ? ContextCompactionConfig.fromPartial(object.contextCompaction)
      : undefined;
    return message;
  },
};

function createBaseAttachmentProcessingConfig(): AttachmentProcessingConfig {
  return { summaryMaxTokens: 0 };
}

export const AttachmentProcessingConfig: MessageFns<AttachmentProcessingConfig> = {
  encode(message: AttachmentProcessingConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.summaryMaxTokens !== 0) {
      writer.uint32(8).int32(message.summaryMaxTokens);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttachmentProcessingConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttachmentProcessingConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.summaryMaxTokens = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttachmentProcessingConfig {
    return {
      summaryMaxTokens: isSet(object.summaryMaxTokens)
        ? globalThis.Number(object.summaryMaxTokens)
        : isSet(object.summary_max_tokens)
        ? globalThis.Number(object.summary_max_tokens)
        : 0,
    };
  },

  toJSON(message: AttachmentProcessingConfig): unknown {
    const obj: any = {};
    if (message.summaryMaxTokens !== 0) {
      obj.summaryMaxTokens = Math.round(message.summaryMaxTokens);
    }
    return obj;
  },

  create(base?: DeepPartial<AttachmentProcessingConfig>): AttachmentProcessingConfig {
    return AttachmentProcessingConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttachmentProcessingConfig>): AttachmentProcessingConfig {
    const message = createBaseAttachmentProcessingConfig();
    message.summaryMaxTokens = object.summaryMaxTokens ?? 0;
    return message;
  },
};

function createBaseContextCompactionConfig(): ContextCompactionConfig {
  return {
    enabled: undefined,
    maxTokens: undefined,
    keepLastN: undefined,
    minMessages: undefined,
    maxSummarizationWindow: undefined,
  };
}

export const ContextCompactionConfig: MessageFns<ContextCompactionConfig> = {
  encode(message: ContextCompactionConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enabled !== undefined) {
      writer.uint32(8).bool(message.enabled);
    }
    if (message.maxTokens !== undefined) {
      writer.uint32(16).int32(message.maxTokens);
    }
    if (message.keepLastN !== undefined) {
      writer.uint32(24).int32(message.keepLastN);
    }
    if (message.minMessages !== undefined) {
      writer.uint32(32).int32(message.minMessages);
    }
    if (message.maxSummarizationWindow !== undefined) {
      writer.uint32(40).int32(message.maxSummarizationWindow);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ContextCompactionConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseContextCompactionConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.maxTokens = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.keepLastN = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.minMessages = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.maxSummarizationWindow = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ContextCompactionConfig {
    return {
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : undefined,
      maxTokens: isSet(object.maxTokens)
        ? globalThis.Number(object.maxTokens)
        : isSet(object.max_tokens)
        ? globalThis.Number(object.max_tokens)
        : undefined,
      keepLastN: isSet(object.keepLastN)
        ? globalThis.Number(object.keepLastN)
        : isSet(object.keep_last_n)
        ? globalThis.Number(object.keep_last_n)
        : undefined,
      minMessages: isSet(object.minMessages)
        ? globalThis.Number(object.minMessages)
        : isSet(object.min_messages)
        ? globalThis.Number(object.min_messages)
        : undefined,
      maxSummarizationWindow: isSet(object.maxSummarizationWindow)
        ? globalThis.Number(object.maxSummarizationWindow)
        : isSet(object.max_summarization_window)
        ? globalThis.Number(object.max_summarization_window)
        : undefined,
    };
  },

  toJSON(message: ContextCompactionConfig): unknown {
    const obj: any = {};
    if (message.enabled !== undefined) {
      obj.enabled = message.enabled;
    }
    if (message.maxTokens !== undefined) {
      obj.maxTokens = Math.round(message.maxTokens);
    }
    if (message.keepLastN !== undefined) {
      obj.keepLastN = Math.round(message.keepLastN);
    }
    if (message.minMessages !== undefined) {
      obj.minMessages = Math.round(message.minMessages);
    }
    if (message.maxSummarizationWindow !== undefined) {
      obj.maxSummarizationWindow = Math.round(message.maxSummarizationWindow);
    }
    return obj;
  },

  create(base?: DeepPartial<ContextCompactionConfig>): ContextCompactionConfig {
    return ContextCompactionConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ContextCompactionConfig>): ContextCompactionConfig {
    const message = createBaseContextCompactionConfig();
    message.enabled = object.enabled ?? undefined;
    message.maxTokens = object.maxTokens ?? undefined;
    message.keepLastN = object.keepLastN ?? undefined;
    message.minMessages = object.minMessages ?? undefined;
    message.maxSummarizationWindow = object.maxSummarizationWindow ?? undefined;
    return message;
  },
};

function createBasePeriodicRescanConfig(): PeriodicRescanConfig {
  return { enabled: false, intervalMinutes: 0, periodMinutes: 0 };
}

export const PeriodicRescanConfig: MessageFns<PeriodicRescanConfig> = {
  encode(message: PeriodicRescanConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enabled !== false) {
      writer.uint32(8).bool(message.enabled);
    }
    if (message.intervalMinutes !== 0) {
      writer.uint32(16).int32(message.intervalMinutes);
    }
    if (message.periodMinutes !== 0) {
      writer.uint32(24).int32(message.periodMinutes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PeriodicRescanConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePeriodicRescanConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.intervalMinutes = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.periodMinutes = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PeriodicRescanConfig {
    return {
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      intervalMinutes: isSet(object.intervalMinutes)
        ? globalThis.Number(object.intervalMinutes)
        : isSet(object.interval_minutes)
        ? globalThis.Number(object.interval_minutes)
        : 0,
      periodMinutes: isSet(object.periodMinutes)
        ? globalThis.Number(object.periodMinutes)
        : isSet(object.period_minutes)
        ? globalThis.Number(object.period_minutes)
        : 0,
    };
  },

  toJSON(message: PeriodicRescanConfig): unknown {
    const obj: any = {};
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.intervalMinutes !== 0) {
      obj.intervalMinutes = Math.round(message.intervalMinutes);
    }
    if (message.periodMinutes !== 0) {
      obj.periodMinutes = Math.round(message.periodMinutes);
    }
    return obj;
  },

  create(base?: DeepPartial<PeriodicRescanConfig>): PeriodicRescanConfig {
    return PeriodicRescanConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PeriodicRescanConfig>): PeriodicRescanConfig {
    const message = createBasePeriodicRescanConfig();
    message.enabled = object.enabled ?? false;
    message.intervalMinutes = object.intervalMinutes ?? 0;
    message.periodMinutes = object.periodMinutes ?? 0;
    return message;
  },
};

function createBaseDevConfig(): DevConfig {
  return {};
}

export const DevConfig: MessageFns<DevConfig> = {
  encode(_: DevConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DevConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDevConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DevConfig {
    return {};
  },

  toJSON(_: DevConfig): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<DevConfig>): DevConfig {
    return DevConfig.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<DevConfig>): DevConfig {
    const message = createBaseDevConfig();
    return message;
  },
};

function createBaseDevCommand(): DevCommand {
  return {};
}

export const DevCommand: MessageFns<DevCommand> = {
  encode(_: DevCommand, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DevCommand {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDevCommand();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DevCommand {
    return {};
  },

  toJSON(_: DevCommand): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<DevCommand>): DevCommand {
    return DevCommand.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<DevCommand>): DevCommand {
    const message = createBaseDevCommand();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
